<template>
  <v-container style="max-width: 100%">
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="basil"
      grow
    >
      <v-tab
        v-for="itemTab in itemsTab"
        :key="itemTab"
      >
        <span class="ppc_darkgreen--text">{{ itemTab }}</span>
      </v-tab>
    </v-tabs>
    
    <v-tabs-items v-model="tab">
      <!-- Placements -->
      <v-tab-item>
        <span class="d-flex flex-column">
          <v-row justify="center">
            <div class="d-flex flex-row elevation-1 px-2 pt-4 mb-2">
              <!-- <div v-if="this.$store.state.user === 'Coen'">
                                <v-btn @click="doResourcesAcc()">do Resources</v-btn>
                            </div> -->
              <v-radio-group
                v-model="scopeResourcesPlanned"
                row
                class="mt-4 d-flex flex-column"
                @change="changeScopeResourcesPlanned($event)"
              >
                <div class="d-flex flex-row flex-wrap">
                  <div class="d-flex flex-column">
                    <div class="d-flex justify-center">
                      <v-radio
                        label="Ongoing"
                        value="ongoing"
                        class="my-0 py-0"
                      />
                    </div>
                    <v-divider class="my-2" />
                    <div class="d-flex flex-row flex-wrap">
                      <div class="d-flex flex-row flex-wrap">
                        <v-radio
                          label="Not Confirmed"
                          value="notConfirmed"
                          class="my-0 py-0"
                        />
                        <v-radio
                          label="To be placed"
                          value="notPlaced"
                          class="my-0 py-0"
                        />
                        <v-radio
                          label="Placed"
                          value="placed"
                          class="my-0 py-0"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-space-between mx-2">
                    <v-radio
                      label="Completed"
                      value="completed"
                      class="my-0 py-0"
                    />
                  </div>
                </div>
              </v-radio-group>
            </div>
          </v-row>
          <v-data-table
            v-model="selectedReservation"
            :headers="headersResourcesScope"
            :items="resourcesScope"
            sort-by="start"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [itemsPerPage]
            }"
            :search="searchResourcesScope"
            show-select
            :single-select="selectedReservationSingleSelect"
            @input="selectResourceReservation"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <div class="d-flex flex-row flex-wrap justify-center">
                  <!-- <v-toolbar-title class="mr-4">Resources</v-toolbar-title> -->
                  <v-card flat>
                    <v-text-field
                      v-model="searchResourcesScope"
                      append-icon="$vuetify.icons.icon_mdi_magnify"
                      :label="'Search ' + `${ resourcesScope.length }` + ' accommodation(s)'"
                      single-line
                      hide-details
                      style="width: 300px"
                      clearable
                    />
                  </v-card>
                </div>
                <v-spacer />
                <v-btn
                  :disabled="selectedReservation.length < 1 || updatingResources || !infoToClientPossible"
                  class="ml-2"
                  small
                  @click="sendInfoToClientConfirm()"
                >
                  Send Info to Client(s)
                </v-btn>
                <v-btn
                  :disabled="selectedReservation.length < 1 || updatingResources || infoToAccommodation === null"
                  class="ml-2"
                  small
                  @click="goFichaDeAlojamiento(infoToAccommodation)"
                >
                  Send Info to Accommodation
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:[`item.full_name`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex flex-row align-center">
                    <v-btn 
                      x-small
                      fab
                      v-bind="attrs"
                      class="mr-3" 
                      v-on="on"
                      @click="goClient(item.client_id, item.id)"
                    >
                      <v-icon>mdi-arrow-up-bold</v-icon>
                    </v-btn>
                    <strong>{{ item.full_name }}</strong>
                  </div>
                </template>
                <span>Go to Client</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.email`]="{ item }">
              <v-icon
                v-if="item.email !== null"
                small
                color="ppc_darkgreen"
              >$vuetify.icons.icon_mdi_check</v-icon>
            </template>
            <template v-slot:[`item.start`]="{ item }">
              <span v-html="formattedDate(item.start, 'date')" />
            </template>
            <template v-slot:[`item.end`]="{ item }">
              <span v-html="formattedDate(item.end, 'date')" />
            </template>
            <template v-slot:[`item.totalSecurityDeposit`]="{ item }">
              <span v-if="hasMoney(item.totalSecurityDeposit)">
                $ {{ formatMoney(item.totalSecurityDeposit) }}
              </span>
            </template>
            <template v-slot:[`item.family`]="{ item }">
              <span v-if="item.family == 0">Apartment</span>
              <span v-else>Family</span>
            </template>
            <template v-slot:[`item.statusResourceId`]="{ item }">
              <v-chip
                :color="getStatusResource(item.statusResourceId).color"
                text-color="white"
                v-html="getStatusResource(item.statusResourceId).name"
              />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                small
                class="mr-2"
                :disabled="updatingResources"
                @click="openDialogEditResource(item.id)"
              >
                $vuetify.icons.icon_mdi_pencil
              </v-icon>
            </template>
          </v-data-table>
        </span>


        <v-dialog
          v-model="dialogEditResource"
          max-width="1100px"
          :retain-focus="false"
          class="rounded-xl"
        >
          <v-card
            class="d-flex flex-row flex-wrap rounded-xl"
            color="blue"
          >
            <v-card
              flat
              class="d-flex flex-row flex-wrap justify-space-between"
              color="blue"
              style="width: 100%"
            >
              <div>
                <v-card-title>
                  <span class="white--text mr-2">Accommodation #{{ updatedResource.number_type }}</span> 
                  <span
                    v-if="updatedResource.family == 0"
                    class="white--text"
                  >Apartment</span>
                  <span
                    v-if="updatedResource.family == 1"
                    class="white--text"
                  >Family {{ updatedResource.contact_full_name }}</span>
                </v-card-title>
                <v-card-subtitle>
                  <div class="white--text">
                    {{ updatedResource.full_name }}
                  </div>
                  <div class="white--text">
                    {{ updatedResource.accommodation_class }}
                  </div>
                </v-card-subtitle>
              </div>
              <v-chip
                class="ma-4"
                :color="getStatusResource(updatedResource.statusResourceId).color"
                text-color="white"
                v-html="getStatusResource(updatedResource.statusResourceId).name"
              />
            </v-card>
            <div
              class="d-flex flex-column"
              color="blue lighten-2"
              style="max-width: 320px"
            >
              <v-card-text>
                <!-- <v-btn small rounded :disabled="!updatedResource.room_id" @click="openAvailability(updatedResource.accommodation_id, updatedResource.start)" class="mb-2">availability</v-btn> -->
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="from"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(updatedResource.start)"
                      readonly
                      class="text-input-white"
                      color="white"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="updatedResource.start"
                    no-title
                    scrollable
                    color="blue"
                    @change="calcPaymentResource(updatedResource)"
                  />
                </v-menu>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="until"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(updatedResource.end)"
                      readonly
                      class="text-input-white"
                      color="white"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="updatedResource.end"
                    no-title
                    scrollable
                    :min="updatedResource.start"
                    color="blue"
                    @change="calcPaymentResource(updatedResource)"
                  />
                </v-menu>
                <div class="mb-4">
                  Duration: {{ updatedResource.duration }} night(s)
                </div>
                <v-select
                  v-model="updatedResource.room_id"
                  :items="availableRooms"
                  item-text="listEntry"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Room"
                  validate-on-blur
                  clearable
                  color="white"
                  item-color="black"
                  :disabled="updatedResource.start === null || updatedResource.end === null"
                  @click:clear="updatedResource.room_id = null, updatedResource.reserved = null"
                  @change="calcPaymentResource(updatedResource)"
                >
                  <template #selection="{ item }">
                    <span class="white--text">{{ item.roomSelectName }}</span>
                  </template>
                  <template
                    slot="item"
                    slot-scope="data"
                  >
                    <v-icon
                      v-if="data.item.success"
                      small
                      color="ppc_darkgreen"
                      class="mr-2"
                    >
                      $vuetify.icons.icon_mdi_check
                    </v-icon>  {{ data.item.listEntry }}
                  </template>
                </v-select>
                <v-textarea
                  v-model="updatedResource.comments"
                  class="rounded-xl"
                  auto-grow
                  clearable
                  counter="255"
                  outlined
                  color="white"
                  label="Comments (255 max)"
                  :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                />
              </v-card-text>
            </div>
            <div
              class="d-flex flex-column"
              color="blue lighten-2"
              style="max-width: 320px"
            >
              <v-card-text>
                <v-text-field
                  v-model="updatedResource.extras"
                  label="Pickup, Fixed & Extras (PEN)"
                  class="text-input-white"
                  color="white"
                  @change="calcPaymentResource(updatedResource)"
                />
                <div
                  v-if="updatedResource.payment > 0 && updatedResource.room_id > 0"
                  class="mb-5"
                >
                  {{ updatedResource.paymentDescription }} =
                </div>
                <!-- <div class="mb-5" v-if="updatedResource.payment > 0">Total: ({{ updatedResource.rate }} x {{ updatedResource.duration }}) + {{ updatedResource.extras }} = </div> -->
                <v-text-field
                  v-if="updatedResource.room_id > 0"
                  v-model="updatedResource.payment"
                  label="Total Payment (PEN)"
                  class="text-input-white"
                  color="white"
                  disabled
                />
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span class="d-flex flex-row">
                      <v-text-field
                        label="Info to placement"
                        v-bind="attrs"
                        prepend-icon="$vuetify.icons.icon_mdi_calendar"
                        :value="formattedDate(updatedResource.info_to_provider)"
                        clearable
                        readonly
                        class="text-input-white"
                        color="white"
                        :disabled="updatedResource.room_id === null"
                        v-on="on"
                        @click:clear="updatedResource.info_to_provider = null"
                      />
                    </span>
                  </template>
                  <v-date-picker
                    v-model="updatedResource.info_to_provider"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Reserved"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(updatedResource.reserved)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="updatedResource.room_id === null"
                      v-on="on"
                      @click:clear="updatedResource.reserved = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="updatedResource.reserved"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Info to client"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(updatedResource.info_to_client)"
                      clearable
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="updatedResource.room_id === null"
                      v-on="on"
                      @click:clear="updatedResource.info_to_client = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="updatedResource.info_to_client"
                    no-title
                    scrollable
                    color="blue"
                    @change="checkResourceDates(updatedResource)"
                  />
                </v-menu>
              </v-card-text>
            </div>
            <div
              class="d-flex flex-column"
              style="max-width: 400px"
            >
              <v-card-title
                class="white--text"
              >
                Pick Up Data
              </v-card-title>
              <v-btn
                x-small
                class="pa-4 ma-4 mt-0"
                @click="copyPickupFromClientInfo()"
                :disabled="pickupClientInfoIsSameAsResource"
              >
                Copy from Client Info
              </v-btn>
              <v-radio-group
                v-model="updatedResource.pickup_type"
                row
                class="mt-0 mx-4"
                color="white"
              >
                <v-radio
                  label="To be confirmed"
                  value="To be confirmed"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Flight"
                  value="Flight"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Bus"
                  value="Bus"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Address Cusco"
                  value="Address"
                  class="my-0 py-0"
                  color="white"
                />
                <v-radio
                  label="Not applicable"
                  value="Not applicable"
                  class="my-0 py-0"
                  color="white"
                />
              </v-radio-group>
              <v-card
                flat
                class="d-flex flex-row flex-wrap"
                color="blue"
                v-if="updatedResource.pickup_type !== 'To be confirmed' && updatedResource.pickup_type !== 'Not applicable'"
              >
                <v-card flat color="blue">
                  <v-text-field 
                    v-if="updatedResource.pickup_type !== 'Address'" 
                    v-model.trim="updatedResource.pickup_company" 
                    label="Company" 
                    prepend-icon="$vuetify.icons.icon_mdi_domain  white--text"
                    clearable
                    class="pa-2"
                    color="white"
                  />
                </v-card>
                <v-card flat color="blue">
                  <v-text-field 
                    v-if="updatedResource.pickup_type === 'Flight'" 
                    v-model.trim="updatedResource.pickup_nr" 
                    label="Flight nr" 
                    prepend-icon="mdi-airplane  white--text" 
                    clearable
                    class="pa-2"
                    color="white"
                  />
                </v-card>
                <v-card flat color="blue">
                  <v-text-field 
                    v-if="updatedResource.pickup_type !== 'Address'" 
                    v-model.trim="updatedResource.pickup_from" 
                    label="From" 
                    prepend-icon="$vuetify.icons.icon_mdi_map_marker white--text" 
                    clearable
                    class="pa-2"
                    color="white"
                  />
                </v-card>
                <v-textarea
                  v-if="updatedResource.pickup_type === 'Address'"
                  v-model="updatedResource.pickup_address"
                  style="min-width: 200px"
                  class="rounded-xl pa-2"
                  auto-grow
                  clearable
                  outlined
                  counter="150"
                  rows="2"
                  label="Address in Cusco (150 max)"
                  :rules="[v => (v || '' ).length <= 150 || 'Comments must be 150 characters or less']"
                  prepend-icon="$vuetify.icons.icon_mdi_map_marker white--text"
                  color="white"
                />
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="mt-5"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Arrival date"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar white--text"
                      :value="formattedDate(updatedResource.pickup_date)"
                      clearable
                      readonly
                      class="pa-2 pb-0"
                      v-on="on"
                      @click:clear="updatedResource.pickup_date=null"
                      color="white"
                      style="max-width: 200px"
                    />
                  </template>
                  <v-date-picker
                    v-model="updatedResource.pickup_date"
                    no-title
                    scrollable
                  />
                </v-menu>
                <v-chip
                  v-if="updatedResource.pickup_date && !checkIfPickupDateIsStart"
                  color="orange"
                  text-color="white"
                  class="ma-3 mt-0 mb-6"
                >
                  Pickup date ≠ accommodation start date
                </v-chip>
                <v-card flat color="blue">
                  <v-text-field
                    :value="updatedResource.pickup_time ? updatedResource.pickup_time.slice(0, 5) : ''"
                    label="Time (hh:mm)"
                    prepend-icon="mdi-clock-time-nine-outline white--text"
                    clearable
                    class="pa-2"
                    @input="updatedResource.pickup_time = $event"
                    color="white"
                  />
                </v-card>
                <v-card flat color="blue">
                  <v-select
                    v-model="updatedResource.pickup_staff_id"
                    :items="$store.state.users"
                    item-text="name"
                    item-value="id"
                    clearable
                    dense
                    class="pa-2"
                    hide-details
                    placeholder="Assign..."
                    prepend-icon="mdi-account white--text"
                    color="white"
                    :menu-props="{ contentClass: 'pickup-menu' }"
                    @click:clear="updatedResource.pickup_staff_id = null"
                  />
                </v-card>
              </v-card>
            </div>
            <v-card-actions
              class="d-flex flex-row flex-wrap justify-space-between"
              color="blue lighten-2"
              style="width: 100%"
            >
              nr: {{ updatedResource.id }}
              <v-btn
                v-if="updatedResource.transaction_id"
                color="blue lighten-3"
                class="ma-4"
                @click="openTransactionOutgoings(updatedResource.transaction_id)"
              >
                <v-icon color="white">
                  $vuetify.icons.icon_mdi_credit_card
                </v-icon>
                <span class="white--text">Open Transaction</span>
              </v-btn>
              <v-spacer />
              <v-btn
                color="white"
                text
                @click="dialogEditResource = false, updatingResources = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="white"
                text
                @click="dialogEditResource = false, insertUpdateResource()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogEditMultipleResources"
          max-width="640px"
          :retain-focus="false"
        >
          <v-card
            class="d-flex flex-row flex-wrap"
            color="green lighten-2"
          >
            <v-card
              flat
              class="d-flex flex-row flex-wrap justify-space-between"
              color="green lighten-2"
              style="width: 100%"
            >
              <div>
                <v-card-title>
                  <span class="white--text mr-2">Multiple ({{ selectedReservation.length }}) Accommodations</span>
                  <span
                    v-if="resourcesMultiple.family == 0"
                    class="white--text"
                  >Apartment {{ resourcesMultiple.accommodation_class }}</span>
                  <span
                    v-if="resourcesMultiple.family == 1"
                    class="white--text"
                  >Family {{ resourcesMultiple.contact_full_name }} {{ resourcesMultiple.accommodation_class }}</span>
                </v-card-title>
              </div>
            </v-card>
            <div
              class="d-flex flex-column"
              color="green lighten-2"
              style="max-width: 320px"
            >
              <v-card-text>
                <v-select
                  v-model="resourcesMultiple.room_id"
                  :items="availableRooms"
                  item-text="listEntry"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  :label="resourcesMultiple.room_id_label"
                  validate-on-blur
                  color="white"
                  item-color="black"
                  @click:clear="resourcesMultiple.room_id = null"
                  @input="resourcesMultiple.clearRoomId = false"
                >
                  <template #selection="{ item }">
                    <span class="white--text">{{ item.roomSelectName }}</span>
                  </template>
                  <template
                    slot="item"
                    slot-scope="data"
                  >
                    <v-icon
                      v-if="data.item.success"
                      small
                      color="ppc_darkgreen"
                      class="mr-2"
                    >
                      $vuetify.icons.icon_mdi_check
                    </v-icon>  {{ data.item.listEntry }}
                  </template>
                </v-select>
                <v-checkbox
                  v-model="resourcesMultiple.clearRoomId"
                  label="clear Room"
                  class="mt-0"
                  :disabled="resourcesMultiple.room_id_label === 'Room*'"
                  @change="clearRoomId($event)"
                />
                <!-- <v-btn small rounded :disabled="!resourcesMultiple.room_id" @click="openAvailability(resourcesMultiple.accommodation_id, resourcesMultiple.start)" class="mb-2">availability</v-btn> -->
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="resourcesMultiple.start_label"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourcesMultiple.start)"
                      readonly
                      class="text-input-white"
                      color="white"
                      v-on="on"
                      @click:clear="resourcesMultiple.start = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourcesMultiple.start"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="resourcesMultiple.end_label"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourcesMultiple.end)"
                      readonly
                      class="text-input-white"
                      color="white"
                      v-on="on"
                      @click:clear="resourcesMultiple.end = null"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourcesMultiple.end"
                    no-title
                    scrollable
                    :min="resourcesMultiple.start"
                    color="blue"
                  />
                </v-menu>
                <div class="mb-4">
                  Duration: {{ resourcesMultiple.duration }} night(s)
                </div>
                <v-textarea
                  v-model="resourcesMultiple.comments"
                  class="rounded-xl mb-0"
                  auto-grow
                  counter="255"
                  outlined
                  color="white"
                  :label="resourcesMultiple.comments_label"
                  :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
                  @input="resourcesMultiple.clearComments = false"
                />
                <v-checkbox
                  v-model="resourcesMultiple.clearComments"
                  label="clear all comments"
                  class="mt-0"
                  :disabled="resourcesMultiple.comments_label === 'Comments (255 max)*'"
                  @change="clearComments($event)"
                />
              </v-card-text>
            </div>
            <div
              class="d-flex flex-column"
              color="green lighten-2"
              style="max-width: 320px"
            >
              <v-card-text>
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span class="d-flex flex-row">
                      <v-text-field
                        :label="resourcesMultiple.info_to_provider_label"
                        v-bind="attrs"
                        prepend-icon="$vuetify.icons.icon_mdi_calendar"
                        :value="formattedDate(resourcesMultiple.info_to_provider)"
                        readonly
                        class="text-input-white"
                        color="white"
                        :disabled="resourcesMultiple.room_id === null"
                        v-on="on"
                        @click:clear="resourcesMultiple.info_to_provider = null"
                        @input="resourcesMultiple.clearInfoToPlacement = false"
                      />
                    </span>
                  </template>
                  <v-date-picker
                    v-model="resourcesMultiple.info_to_provider"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-checkbox
                  v-model="resourcesMultiple.clearInfoToPlacement"
                  label="clear Info to Placement"
                  class="mt-0"
                  :disabled="resourcesMultiple.info_to_provider_label === 'Info to placement*'"
                  @change="clearInfoToPlacement($event)"
                />
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="resourcesMultiple.reserved_label"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourcesMultiple.reserved)"
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resourcesMultiple.room_id === null"
                      v-on="on"
                      @click:clear="resourcesMultiple.reserved = null"
                      @input="resourcesMultiple.clearReserved = false"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourcesMultiple.reserved"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
                <v-checkbox
                  v-model="resourcesMultiple.clearReserved"
                  label="clear Info to Provider"
                  class="mt-0"
                  :disabled="resourcesMultiple.reserved_label === 'Reserved*'"
                  @change="clearReserved($event)"
                />
                <v-menu
                  transition="scale-transition"
                  offset-y
                  class="my-5"
                  max-width="100%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="resourcesMultiple.info_to_client_label"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      :value="formattedDate(resourcesMultiple.info_to_client)"
                      readonly
                      class="text-input-white"
                      color="white"
                      :disabled="resourcesMultiple.room_id === null"
                      v-on="on"
                      @click:clear="resourcesMultiple.info_to_client = null"
                      @input="resourcesMultiple.clearInfoToClient = false"
                    />
                  </template>
                  <v-date-picker
                    v-model="resourcesMultiple.info_to_client"
                    no-title
                    scrollable
                    color="blue"
                    @change="checkResourceDates(resourcesMultiple)"
                  />
                </v-menu>
                <v-checkbox
                  v-model="resourcesMultiple.clearInfoToClient"
                  label="clear Info to Provider"
                  class="mt-0"
                  :disabled="resourcesMultiple.info_to_client_label === 'Info to client*'"
                  @change="clearInfoToClient($event)"
                />
              </v-card-text>
              <div class="mb-4">
                <span>* field is empty in all resources</span>
              </div>
            </div>
            <v-card-actions
              class="d-flex flex-row flex-wrap justify-space-between"
              color="green lighten-2"
              style="width: 100%"
            >
              <v-spacer />
              <v-btn
                color="white"
                text
                @click="dialogEditMultipleResources = false, updatingResources = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="white"
                text
                @click="insertUpdateResourcesMultiple()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>
      <!-- payments -->
      <v-tab-item>
        <v-row class="my-4 d-flex flex-column justify-space-around">
          <div class="d-flex flex-row justify-space-around">
            <v-row justify="center">
              <v-card-title>Pay until {{ startOfNextMonth }}</v-card-title>
              <v-date-picker
                :value="monthCalcPaymentsAccommodation.month"
                type="month"
                no-title
                :allowed-dates="allowedMonths"
                :disabled="$store.getters.loadingApp === 1"
                @input="saveCalcPaymentsAccommodation(monthCalcPaymentsAccommodation.type, $event)"
              />
            </v-row>
          </div>
          <v-card
            v-for="(family, index) in paymentsContactsRender"
            :key="index"
            flat
          >
            <div class="d-flex flex-row">
              <div>
                <v-card-title>{{ family.family }}</v-card-title>
                <v-card-subtitle v-if="family.totalPayment != null">
                  Total to pay: {{ familyTotalPaymentFormatted(family) }} PEN
                </v-card-subtitle>
              </div>
              <v-btn
                color="grey"
                dark
                class="ma-2"
                @click="goPaymentAccommodationForm(family)"
              >
                Form
              </v-btn>
              <v-btn
                color="grey"
                dark
                class="ma-2"
                @click="addPayment(family)"
              >
                Pay
              </v-btn>
            </div>
            <v-data-table
              :headers="headersPaymentsFamilies"
              :items="family.resources"
              class="elevation-1 my-4"
              :items-per-page="-1"
              disable-pagination
              hide-default-footer
              sort-by="full_name"
              :disabled="$store.getters.loadingApp === 1"
            >
              <template v-slot:[`item.full_name`]="{ item }">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      small 
                      rounded 
                      v-bind="attrs"
                      v-on="on" 
                      @click="goClient(item.client_id, item.id)"
                    >
                      {{ item.full_name }}
                    </v-btn>
                  </template>
                  <span>go to client</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.stay`]="{ item }">
                <span>{{ formattedDate(item.start, 'day-month-year') }} - {{ formattedDate(item.end, 'day-month-year') }}</span>
              </template>
              <template v-slot:[`item.toPayNow`]="{ item }">
                <span v-if="hasMoney(item.toPayNow)">
                  {{ formatMoney(item.toPayNow) }}
                </span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openDialogEditResource(item.id)"
                >
                  $vuetify.icons.icon_mdi_pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-row>
      </v-tab-item>
      <!-- Families -->
      <v-tab-item>
        <v-data-table
          :headers="headersFamilies"
          :items="filteredFamilies"
          class="elevation-1"
          :items-per-page="-1"
          disable-pagination
          hide-default-footer
          sort-by="contact"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-row justify="center">
                <v-radio-group
                  v-model="showFamilies"
                  column
                  @change="filterFamilias()"
                >
                  <div class="d-flex flex-row flex-wrap">
                    <v-radio
                      label="Active"
                      value="active"
                      class="my-0 py-0 mx-2"
                    />
                    <v-radio
                      label="Obsolete"
                      value="obsolete"
                      class="my-0 py-0 mx-2"
                    />
                  </div>
                </v-radio-group>
              </v-row>
              <v-spacer />
              <v-btn
                color="ppc_pink"
                dark
                small
                absolute
                right
                fab
                @click="editedAcc.family = 1, editedAcc.security_deposit = 0, openDialogAcc()"
              >
                <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.send`]="{ item }">
            <v-btn
              v-if="item.send"
              x-small 
              rounded
              class="mr-2"
              :disabled="$store.getters.loadingApp === 1"
              @click="goFichaDeAlojamiento(item.contact_id)"
            >
              Send ({{ item.reservations }})
            </v-btn>
          </template>
          <template v-slot:[`item.contact`]="{ item }">
            {{ item.contact }}
            <v-btn
              v-if="item.contact" 
              fab 
              color="ppc_pink"
              height="20px"
              width="20px"
              right
              top
              class="ml-3"
              @click="openContactInfo(item)"
            >
              <v-icon color="white">
                $vuetify.icons.icon_mdi_information_variant
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.amountRooms`]="{ item }">
            <span class="mr-2">{{ item.amountRooms }}</span>
            <v-btn
              height="20px"
              width="20px"
              fab
              color="ppc_pink"
            >
              <v-icon
                small
                color="white"
                @click="editRooms(item)"
              >
                $vuetify.icons.icon_mdi_pencil
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.pets`]="{ item }">
            <v-icon
              v-if="`${item.pets}` === 'have pets'"
              small
              color="ppc_darkgreen"
            >
              $vuetify.icons.icon_mdi_check
            </v-icon>
          </template>
          <template v-slot:[`item.vegetarian`]="{ item }">
            <v-icon
              v-if="`${item.vegetarian}` === 'cooks vegetarian'"
              small
              color="ppc_darkgreen"
            >
              $vuetify.icons.icon_mdi_check
            </v-icon>
          </template>
          <template v-slot:[`item.vegan`]="{ item }">
            <v-icon
              v-if="`${item.vegan}` === 'cooks vegan'"
              small
              color="ppc_darkgreen"
            >
              $vuetify.icons.icon_mdi_check
            </v-icon>
          </template>
          <template v-slot:[`item.file_id`]="{ item }">
            <v-icon
              v-if="item.file_id !== null"
              small
              color="ppc_darkgreen"
            >
              $vuetify.icons.icon_mdi_check
            </v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editAcc(item)"
            >
              $vuetify.icons.icon_mdi_pencil
            </v-icon>
            <v-icon
              small
              @click="deleteAcc(item)"
            >
              $vuetify.icons.icon_mdi_delete
            </v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Apartments -->
      <v-tab-item>
        <v-data-table
          :headers="headersApartments"
          :items="updatedApartments"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-spacer />
              <v-btn
                color="ppc_pink"
                dark
                small
                absolute
                right
                fab
                @click="editedAcc.family = 0, openDialogAcc()"
              >
                <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.amountRooms`]="{ item }">
            <span class="mr-2">{{ item.amountRooms }}</span>
            <v-btn
              height="20px"
              width="20px"
              fab
              color="ppc_pink"
            >
              <v-icon
                small
                color="white"
                @click="editRooms(item)"
              >
                $vuetify.icons.icon_mdi_pencil
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.send`]="{ item }">
            <v-btn
              v-if="item.send"
              x-small 
              rounded
              class="mr-2"
              :disabled="$store.getters.loadingApp === 1"
              @click="goFichaDeAlojamiento(item.contact_id)"
            >
              Send ({{ item.reservations }})
            </v-btn>
          </template>
          <template v-slot:[`item.contact`]="{ item }">
            {{ item.contact }}
            <v-btn
              v-if="item.contact" 
              fab 
              color="ppc_pink"
              height="20px"
              width="20px"
              right
              top
              class="ml-3"
              @click="openContactInfo(item)"
            >
              <v-icon color="white">
                $vuetify.icons.icon_mdi_information_variant
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.file_id`]="{ item }">
            <v-icon
              v-if="item.file_id !== null"
              small
              color="ppc_darkgreen"
            >
              $vuetify.icons.icon_mdi_check
            </v-icon>
          </template>
          <template v-slot:[`item.obsoleteAcc`]="{ item }">
            <v-icon
              v-if="item.obsoleteAcc !== null"
              small
              color="ppc_pink"
            >
              $vuetify.icons.icon_mdi_cancel
            </v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editAcc(item)"
            >
              $vuetify.icons.icon_mdi_pencil
            </v-icon>
            <v-icon
              small
              @click="deleteAcc(item)"
            >
              $vuetify.icons.icon_mdi_delete
            </v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog
      v-model="dialogAcc"
      max-width="800px"
      persistent
    >
      <v-form ref="dialogFormAcc">
        <v-card>
          <v-card-title class="ppc_darkgreen darken-1">
            <span class="headline white--text"> {{ formTitle }} {{ editedAcc.contact }} </span>
          </v-card-title>
          <v-card-text>
            <v-select
              v-model="editedAcc.contact_id"
              :items="$store.state.contacts"
              item-text="full_name"
              item-value="id"
              :menu-props="{ auto: true }"
              label="Select contact"
              single-line
              prepend-icon="$vuetify.icons.icon_mdi_account_group ppc_darkgreen--text"
              validate-on-blur
              clearable
              :rules="inputRulesContactReq"
            />
            <v-card
              v-if="editedAcc.family === 1"
              flat
              class="ma-2"
            >
              <v-card-title>Costs per day (PEN)</v-card-title>
              <v-btn
                color="blue"
                dark
                small
                absolute
                right
                fab
                @click="openDialogAccPrices"
              >
                <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
              </v-btn>
              <v-card-actions>
                <v-data-table
                  v-if="editedAcc.prices"
                  :key="rendererDialogAccTable"
                  :headers="headersAccPrices"
                  :items="editedAcc.prices"
                  class="elevation-1"
                  disable-pagination
                  hide-default-footer
                  sort-by="date_price"
                >
                  <template v-slot:[`item.date_price`]="{ item }">
                    <span v-html="formattedDate(item.date_price, 'date')" />
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editAccPrice(item)"
                    >
                      $vuetify.icons.icon_mdi_pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="deleteAccPrice(item)"
                    >
                      $vuetify.icons.icon_mdi_delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-card-actions>
            </v-card>
            <v-card
              v-if="editedAcc.family === 0"
              flat
              class="ma-2"
            >
              <v-card-title>Payment per client</v-card-title>
              <v-card-actions>
                <div class="d-flex flex-row flex-wrap">
                  <v-text-field
                    v-model.number="editedAcc.payment_apartment"
                    label="PEN"
                    class="mr-2"
                    :disabled="editedAcc.payment_type==='not client dependent' || editedAcc.payment_type==='fixed per stay'"
                  />
                  <v-select
                    v-model="editedAcc.payment_type"
                    :items="payment_types"
                    item-text="text"
                    item-value="value"
                    :menu-props="{ auto: true }"
                    label="per"
                    single-line
                    validate-on-blur
                    clearable
                  />
                </div>
              </v-card-actions>
              <v-card-title>Security Deposit</v-card-title>
              <v-card-actions>
                <div class="d-flex flex-row flex-wrap">
                  <v-text-field
                    v-model.number="editedAcc.security_deposit"
                    label="USD (0 is no deposit)"
                    class="mr-2"
                  />
                </div>
              </v-card-actions>
            </v-card>
            <v-card
              v-if="editedAcc.family === 1"
              flat
              class="d-flex flex-row flex-wrap ma-2"
            >
              <div>
                <v-card-text class="py-0">
                  <v-radio-group
                    v-model="editedAcc.pets"
                    column
                    prepend-icon="mdi-dog-side"
                  >
                    <v-radio
                      label="Does not have pets"
                      value="does not have pets"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="Have pets"
                      value="have pets"
                      class="my-0 py-0"
                    />
                  </v-radio-group>
                </v-card-text>
              </div>
              <div>
                <v-card-text class="py-0">
                  <v-radio-group
                    v-model="editedAcc.vegetarian"
                    column
                    prepend-icon="mdi-pot-steam"
                  >
                    <v-radio
                      label="Cooks vegetarian"
                      value="cooks vegetarian"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="No vegetarian"
                      value="no vegetarian"
                      class="my-0 py-0"
                    />
                  </v-radio-group>
                </v-card-text>
              </div>
              <div>
                <v-card-text class="py-0">
                  <v-radio-group
                    v-model="editedAcc.vegan"
                    column
                    prepend-icon="mdi-flower"
                  >
                    <v-radio
                      label="Cooks vegan"
                      value="cooks vegan"
                      class="my-0 py-0"
                    />
                    <v-radio
                      label="No vegan"
                      value="no vegan"
                      class="my-0 py-0"
                    />
                  </v-radio-group>
                </v-card-text>
              </div>
            </v-card>
            <v-textarea
              v-model="editedAcc.commentsAcc"
              class="rounded-xl mx-3"
              auto-grow
              clearable
              counter="255"
              outlined
              label="Comments (255 max)"
              :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
            />
            <v-card 
              class="d-flex flex-column align-start my-1 mx-3 pa-6 rounded-xl" 
              min-width="400px"
              @drop.prevent="onDrop($event, 'accommodationDescription')"
              @dragover.prevent="dragover = true"
              @dragenter.prevent="dragover = true"
              @dragleave.prevent="dragover = false"
            >
              <v-card flat>
                <h2 class="grey--text">
                  <v-icon
                    size="40"
                    class="mr-2"
                  >
                    mdi-text-box
                  </v-icon>Description
                </h2>
              </v-card>
              <v-card 
                v-if="editedAcc.filename"
                flat 
                class="mx-auto my-5"
              >
                <div
                  class="d-inline-block text-truncate"
                  style="max-width: 400px;"
                >
                  {{ editedAcc.filename }}
                </div>
                <div>Uploaded: {{ formattedDate(editedAcc.file_id, 'date') }}</div>
                <div>
                  <v-btn
                    color="ppc_pink"
                    dark
                    x-small
                    fab
                    class="mx-2 my-0 mt-4"
                    @click="downloadFileAcc(editedAcc.file_id)"
                  >
                    <v-icon>
                      mdi-download
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="ppc_pink"
                    dark
                    x-small
                    fab
                    class="mx-2 my-0 mt-4"
                    @click="editedAcc.filename = null"
                  >
                    <v-icon>
                      $vuetify.icons.icon_mdi_delete
                    </v-icon>
                  </v-btn>
                </div>
              </v-card>
              <v-card
                v-else
                flat
                class="d-flex flex-column align-self-center"
              >
                <v-card
                  flat
                  width="320px"
                >
                  <v-file-input 
                    :rules="fileRules"
                    small-chips 
                    show-size 
                    label="Select pdf" 
                    accept=".pdf"
                    :disabled="selectFileaccommodationDescription"
                    @change="selectFile($event, 'accommodationDescription')"
                  />
                </v-card>
                <v-icon
                  :class="[dragover ? 'mt-2, mb-6' : 'mt-5']"
                  size="60"
                >
                  mdi-cloud-upload
                </v-icon>
              </v-card>
            </v-card>
            <div class="d-flex flex-row flex-wrap">
              <v-checkbox
                :input-value="editedAcc.obsoleteAcc !== null"
                label="Obsolete"
                class="mr-4 mt-0"
                @change="setObsoleteAcc($event)"
              />
              <div
                v-if="editedAcc.obsoleteAcc !== null"
                class="mt-1"
              >
                from {{ formattedDate(editedAcc.obsoleteAcc) }}
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="dialogAcc = false, closeAcc()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="saveAccTotal"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-model="dialogAccPrices"
      max-width="500px"
      persistent
    >
      <v-card
        flat
        class="pa-4"
      >
        <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          class="my-5"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              label="prices start on"
              v-bind="attrs"
              prepend-icon="$vuetify.icons.icon_mdi_calendar"
              :value="formattedDate(editedAccPrices.date_price)"
              readonly
              clearable
              style="max-width: 300px"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="editedAccPrices.date_price"
            no-title
            scrollable
            color="blue"
          />
        </v-menu>
        <v-card
          flat
          class="d-flex flex-row flex-wrap"
        >
          <v-text-field
            v-model="editedAccPrices.price_private"
            label="Private"
            prepend-icon="$vuetify.icons.icon_mdi_account ppc_darkgreen--text"
            style="width: 20px"
          />
          <v-text-field
            v-model="editedAccPrices.price_shared"
            label="Shared"
            prepend-icon="$vuetify.icons.icon_mdi_account_group ppc_darkgreen--text"
            style="width: 20px"
          />
          <v-text-field
            v-model="editedAccPrices.price_bunk"
            label="Bunk"
            prepend-icon="$vuetify.icons.icon_mdi_bunk_bed ppc_darkgreen--text"
            style="width: 20px"
          />
        </v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="saveAccPrice(editedAccPrices)"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogRooms"
      max-width="800px"
      persistent
    >
      <v-card flat>
        <v-data-table
          :headers="headersRooms"
          :items="editRoomsTable"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-toolbar-title>Rooms {{ editedAcc.contact }}</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              />
              <v-spacer />
              <v-btn
                color="ppc_pink"
                dark
                small
                absolute
                right
                fab
                @click="editedRoom.name = '#' + (editRoomsTable.length + 1),dialogRoom = true"
              >
                <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.private_bathroom`]="{ item }">
            <span v-if="item.private_bathroom === 0">shared</span>
            <span
              v-if="item.private_bathroom === 1"
              small
            >private</span>
          </template>
          <template v-slot:[`item.obsoleteRoom`]="{ item }">
            <v-icon
              v-if="item.obsoleteRoom !== null"
              small
              color="ppc_pink"
            >
              $vuetify.icons.icon_mdi_cancel
            </v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editRoom(item)"
            >
              $vuetify.icons.icon_mdi_pencil
            </v-icon>
            <v-icon
              small
              @click="deleteRoom(item)"
            >
              $vuetify.icons.icon_mdi_delete
            </v-icon>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogRooms = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogRoom"
      max-width="800px"
      persistent
    >
      <v-form ref="dialogFormRoom">
        <v-card>
          <v-card-title class="ppc_darkgreen darken-1">
            <span class="headline white--text"> Room {{ editedRoom.name }} </span>
          </v-card-title>
          <v-card-text>
            <v-card
              flat
              class="ma-2"
            >
              <v-text-field
                v-model.number="editedRoom.name"
                label="Name (max 45)"
                counter="255"
                :rules="inputRulesName"
                @change="nameChange = true"
              />
              <v-card-title>Capacity</v-card-title>
              <v-card-actions>
                <v-text-field
                  v-model.number="editedRoom.single_beds"
                  label="Single"
                  prepend-icon="mdi-bed ppc_darkgreen--text"
                  type="number"
                  :rules="numberRule"
                  clearable
                  :disabled="editedRoom.bunk_places > 0"
                />
                <v-text-field
                  v-model.number="editedRoom.double_beds"
                  label="Double"
                  prepend-icon="mdi-bed-king ppc_darkgreen--text"
                  type="number"
                  :rules="numberRule"
                  clearable
                  :disabled="editedRoom.bunk_places > 0"
                />
                <v-text-field
                  v-model.number="editedRoom.bunk_places"
                  label="Bunk Places"
                  prepend-icon="$vuetify.icons.icon_mdi_bunk_bed ppc_darkgreen--text"
                  type="number"
                  :rules="numberRule"
                  clearable
                  :disabled="editedRoom.single_beds > 0 || editedRoom.double_beds > 0"
                />
                <v-checkbox
                  v-model="editedRoom.private_bathroom"
                  label="Has private bathroom"
                  class="mr-4 mt-0"
                  :disabled="editedRoom.bunk_places > 0"
                />
              </v-card-actions>
            </v-card>
            <v-textarea
              v-model="editedRoom.commentsRoom"
              class="rounded-xl mx-3"
              auto-grow
              clearable
              counter="255"
              outlined
              label="Comments (255 max)"
              :rules="[v => (v || '' ).length <= 255 || 'Comments must be 255 characters or less']"
            />
            <div class="d-flex flex-row flex-wrap">
              <v-checkbox
                :input-value="editedRoom.obsoleteRoom !== null"
                label="Obsolete"
                class="mr-4 mt-0"
                @change="setObsoleteRoom($event)"
              />
              <div
                v-if="editedRoom.obsoleteRoom !== null"
                class="mt-1"
              >
                from {{ formattedDate(editedRoom.obsoleteRoom) }}
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="dialogRoom = false, closeRoom()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="saveRoom"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-model="dialogDeleteAcc"
      max-width="500px"
    >
      <v-card>
        <v-card-title>Are you sure you want to delete accommodation {{ editedAcc.contact }}?</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="closeDeleteAcc()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="deleteAccConfirm()"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDeleteRoom"
      max-width="500px"
    >
      <v-card>
        <v-card-title>Are you sure you want to delete room nr. {{ editedRoom.name }}?</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogDeleteRoom = !dialogDeleteRoom"
          >
            Cancel
          </v-btn>
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="deleteRoomConfirm()"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog
        v-model="dialogContactInfo"
        max-width="500px"
      >
        <v-card>
          <v-card-title class="ppc_darkgreen darken-1">
            <span class="headline white--text"> {{ contact.name }} </span>
          </v-card-title>
          <v-card-subtitle
            v-if="contact.organisation"
            class="mt-5"
          >
            <v-icon
              class="mr-2"
            >
              $vuetify.icons.icon_mdi_domain
            </v-icon>
            <span class="font-weight-bold">{{ contact.organisation }}</span>
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col
                v-if="contact.address || contact.country"
                cols="12"
              >
                <v-icon
                  class="mr-2"
                >
                  $vuetify.icons.icon_mdi_map_marker
                </v-icon>
                {{ contact.address }}
                <span v-if="contact.address && contact.country">,</span>
                {{ contact.country }}
              </v-col>
                            
              <v-col
                v-if="contact.phone"
                cols="12"
                sm="6"
              >
                <v-icon
                  class="mr-2"
                >
                  mdi-cellphone ppc_darkgreen--text
                </v-icon>
                {{ contact.phone }}
              </v-col>
              <v-col
                v-if="contact.phone_alt"
                cols="12"
                sm="6"
              >
                <v-icon
                  class="mr-2"
                >
                  mdi-phone ppc_darkgreen--text
                </v-icon>
                {{ contact.phone_alt }}
              </v-col>
              <v-col
                v-if="contact.email"
                cols="12"
                sm="6"
              >   
                <v-icon
                  class="mr-2"
                >
                  mdi-email ppc_darkgreen--text
                </v-icon>
                {{ contact.email }}
              </v-col>
              <v-col
                v-if="contact.comments"
                cols="12"
              >   
                <v-icon
                  class="mr-2"
                >
                  mdi-message-text ppc_darkgreen--text
                </v-icon>
                {{ contact.comments }}
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="ppc_darkgreen darken-1"
              text
              @click="dialogContactInfo = false"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog
      v-model="dialogAvailability"
    >
      <v-card>
        <v-card-title>
          <div class="d-flex flex-row flex-wrap">
            <div class="d-flex flex-row flex-wrap">
              <div>
                <v-btn
                  class="mx-5 mt-4"
                  @click="startCalendar = addDays(startCalendar, -7)"
                >
                  prev week
                </v-btn>
              </div>
              <div>
                <v-menu
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      colls="6"
                      label="from week"
                      v-bind="attrs"
                      prepend-icon="$vuetify.icons.icon_mdi_calendar"
                      clearable
                      readonly
                      :value="formattedDate(startCalendar)"
                      v-on="on"
                      @click:clear="startCalendar = nowDate"
                    />
                  </template>
                  <v-date-picker
                    v-model="startCalendar"
                    no-title
                    scrollable
                    color="blue"
                  />
                </v-menu>
              </div>
              <div>
                <v-btn
                  class="mx-5 mt-4"
                  @click="startCalendar = addDays(startCalendar, 7)"
                >
                  next week
                </v-btn>
              </div>
            </div>
            <div class="ml-9 align-self-center">
              {{ contact }}
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn @click="changeWidthWeek('add')" class="ma-4" :disabled="amountOfWeeks===6">add week</v-btn>
                    <v-btn @click="changeWidthWeek('remove')" class="ma-4" :disabled="amountOfWeeks===1">remove week</v-btn> -->
          <div
            v-for="(stay, indexAcc) in stays"
            :key="indexAcc"
            class="all_stays vuecal__flex"
          >
            <strong class="d-flex align-end"><div
              style="width: 100px; font-size: 14px"
              class="pa-2 mb-4"
            >{{ stay.name }}</div></strong>
            <div
              v-for="week in amountOfWeeks"
              :key="week"
              class="all_weeks"
            >
              <vue-cal 
                xsmall
                hide-view-selector
                :events="stay.nightEvents"
                :selected-date="dateCalendar(week)"
                :time="false"
                :time-from="0"
                :time-step="24 * 60"
                :time-to="24 * 60"
                :snap-to-time="(24 * 60)"
                :disable-views="['years', 'year', 'month', 'day']"
                :editable-events="{ title: false, drag: true, resize: false, delete: false, create: false }"
                :active-view="'week'"
                :style="widthWeek"
              >
                <template v-slot:event="{ event }">
                  <strong>
                    <span
                      class="vuecal__event-title mr-1"
                      v-html="event.title"
                    />
                    <!-- <v-icon class="mr-1" small>
                                            {{ event.icon }}
                                        </v-icon> -->
                    <div
                      class="vuecal__event-content"
                      v-html="event.content"
                    />
                  </strong>
                </template>
              </vue-cal>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogAvailability = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfirmSendInfoToClient"
      persistent
      max-width="80vw"
      width="800px"
    >
      <v-card>
        <v-card-title
          v-if="selectedReservation.length > 0 && selectedReservation"
        >
          Send Info {{ selectedReservation[0].contact_full_name }} to:
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersConfirmSendInfoToClient"
            :items="selectedReservation"
            sort-by="full_name"
            class="elevation-1"
            :items-per-page="-1"
            disable-pagination
            hide-default-footer
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialogConfirmSendInfoToClient = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="sendInfoToClient()"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogFichaDeAlojamiento"
      max-width="80vw"
      class="scroll-y"
    >
      <v-card
        v-if="$store.getters.loadingApp !== 1"
        flat
        class="d-flex justify-space-around"
      >
        <v-card 
          flat
          class="pa-4"
          width="210mm"
        >
          <span
            id="areatoprint"
            class="ma-2"
            v-html="messageHTML"
          />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="dialogFichaDeAlojamiento = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="printDialogContent()"
            >
              Print/Download
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
    
  </v-container>
</template>

<script>

import inputRules from '../mixins/inputRules';
import dayjs from 'dayjs';
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import formattedDate from '../mixins/formattedDate';
import compare from '../mixins/compare';
import decUtil from '@/utils/decimalUtils';

export default {
    components: { 
        VueCal,
    },

    mixins: [inputRules, formattedDate, compare],
    data: () => ({
        startCalendar:  null,
        amountOfWeeks: null,
        widthWeek: 'width: 400px',
        stays: [],
        tab: 0,
        itemsTab: [
            'Placements', 'Payments', 'Families', 'Apartments'
        ],
        decUtil,
      dialogAcc: false,
      dialogAccPrices: false,
      dialogRooms: false,
      dialogRoom: false,
      dialogDeleteAcc: false,
      dialogDeleteRoom: false,
      dialogContactInfo: false,
      dialogEditResource: false,
      dialogEditMultipleResources: false,
      dialogAvailability: false,
      dialogConfirmSendInfoToClient: false,
      dialogFichaDeAlojamiento: false,
      headersConfirmSendInfoToClient: [
        { text: 'Client', value: 'full_name' },
        { text: 'Agency', value: 'agency' },
        { text: 'Email', value: 'email' },
        { text: 'CC', value: 'cc' },
      ],
      headersFamilies: [
        { text: 'Contact', value: 'contact' },
        { text: 'Reservations', value: 'send', sortable: false, width: '100px' },
        { text: 'Rooms', value: 'amountRooms' },
        { text: 'Pets', value: 'pets' },
        { text: 'Vegetarian', value: 'vegetarian' },
        { text: 'Vegan', value: 'vegan' },
        { text: 'Description', value: 'file_id' },
        { text: 'Comments', value: 'commentsAcc' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersApartments: [
        { text: 'Contact', value: 'contact' },
        { text: 'Reservations', value: 'send', sortable: false, width: '100px' },
        { text: 'Rooms', value: 'amountRooms' },
        { text: 'Description', value: 'file_id' },
        { text: 'Comments', value: 'commentsAcc' },
        { text: 'Obsolete', value: 'obsoleteAcc' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersRooms: [
        { text: 'Name', value: 'name' },
        { text: 'Single', value: 'single_beds' },
        { text: 'Double', value: 'double_beds' },
        { text: 'Bunks', value: 'bunk_places' },
        { text: 'Bathroom', value: 'private_bathroom' },
        { text: 'Comments', value: 'commentsRoom' },
        { text: 'Obsolete', value: 'obsoleteRoom' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersResourcesScope: [
          { text: 'Client', value: 'full_name' },
          { text: 'Agency', value: 'agency' },
          { text: 'Email', value: 'email' },
          { text: 'Class', value: 'accommodation_class'},
          { text: 'Room', value: 'accName' },
          { text: 'Project(s)', value: 'projectPlacements' },
          { text: 'Type', value: 'family' },
          { text: 'Start', value: 'start', width: '120px'},
          { text: 'End', value: 'end', width: '120px'},
          { text: 'Paid Sec.Dep.', value: 'totalSecurityDeposit'},
          { text: 'Comments', value: 'comments', groupable: false },
          { text: 'Status', value: 'statusResourceId' },
          { text: 'Open', value: 'actions', sortable: false },
      ],
      headersAccPrices: [
        { text: 'Date', value: 'date_price' },
        { text: 'Private', value: 'price_private' },
        { text: 'Shared', value: 'price_shared' },
        { text: 'Bunk', value: 'price_bunk' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headersPaymentsFamilies: [
        { text: 'client' , value: 'full_name'},
        { text: 'total stay' , value: 'stay'},
        { text: 'class' , value: 'accommodation_class'},
        { text: 'total payment' , value: 'payment'},
        { text: 'total nights' , value: 'duration'},
        // { text: 'service nights' , value: 'servicesDuration'},
        { text: 'nights to be paid', value: 'nightsShouldBePaidNow'},
        { text: 'extras PEN' , value: 'extras'},
        { text: 'already paid PEN' , value: 'amountPaidReceiver'},
        { text: 'calculation' , value: 'paymentDescription'},
        { text: 'to pay now PEN' , value: 'toPayNow'},
        { text: 'open resource', value: 'actions', sortable: false },
      ],
      payment_types: [
        { text: 'per night' , value: 'per night'},
        { text: 'fixed per stay' , value: 'fixed per stay'},
        { text: 'not client dependent' , value: 'not client dependent'},
      ],
      updatedAccommodations: [],
      updatedAccPrices: [],
      updatedRooms: [],
      editRoomsTable: [],
      updatedFamilies: [],
      filteredFamilies: [],
      updatedApartments: [],
      editedIndexAcc: -1,
      editedIndexRoom: -1,
      editedAcc: {
        contact: '',
        contact_id: null,
        family: null,
        price_private: 0,
        price_shared: 0,
        price_bunk: 0,
        date_price: null,
        addon_private_bathroom: 0.00,
        payment_appartment: 0,
        payment_type: 'per night',
        pets: 'does not have pets', 
        vegetarian: 'cooks vegetarian', 
        vegan: 'no vegan', 
        commentsAcc: '',
        obsoleteAcc: null,
      },
      defaultAcc: {
        contact: '',
        contact_id: null,
        family: null,
        price_private: 0,
        price_shared: 0,
        price_bunk: 0,
        date_price: null,
        addon_private_bathroom: 0.00,
        payment_appartment: 0,
        payment_type: 'per night',
        pets: 'does not have pets', 
        vegetarian: 'cooks vegetarian', 
        vegan: 'no vegan', 
        commentsAcc: '',
        obsoleteAcc: null,
      },
      editedRoom: {
        accommodation_id: null,
        single_beds: 0,
        double_beds: 0,
        bunk_places: 0,
        private_bathroom: 0,
        commentsRoom: '',
        obsoleteRoom: null,
      },
      defaultRoom: {
        accommodation_id: null,
        single_beds: 0,
        double_beds: 0,
        bunk_places: 0,
        private_bathroom: 0,
        commentsRoom: '',
        obsoleteRoom: null,
      },
      contact: [],
      resourcesPaymentMonth: [],
      resourcesScope: [],
      resourcesLoaded: [],
      updatedResource: [],
      resourcesMultiple: [],
      nowDate: null,
      nameChange: false,
      paymentsContactsRender: [],
      loadingbuttonAllPlacements: false,
      searchResourcesNotPlaced: '',
      searchResourcesScope: '',
      scopeResourcesPlanned: 'ongoing',
      availableRooms: [],
      selectedReservation: [],
      selectedReservationSingleSelect: true,
      rendererDialogAccTable: Math.random(),
      editedAccPrices: {},
      updatingResources: false,
      showFamilies: "active",
      infoToClientPossible: false,
      infoToAccommodation: null,
      openMultipleResourcesPossible: false,
      fileRules: [
        file => !file || file.size < 1e6 || 'File size should be less than 1 MB!'
      ],
      selectFileaccommodationDescription: false,
      accommodationDescription: null,
      dragover: false,
      messageHTML: '',
      pickupClientInfo: {},
    }),

    computed: {
        formTitle () {
            return this.editedIndexAcc === -1 ? (this.editedAcc.family === 0 ? 'New Apartment ' : 'New Family ') : (this.editedAcc.family === 0 ? 'Apartment ' : 'Family ')
        },

        endOfMonth () {
            return dayjs(this.monthCalcPaymentsAccommodation.month).endOf('month').format('YYYY-MM-DD')
        },

        startOfMonth () {
            return dayjs(this.monthCalcPaymentsAccommodation.month).startOf('month').format('YYYY-MM-DD')
        },

        startOfNextMonth () {
            return dayjs(dayjs(this.monthCalcPaymentsAccommodation.month).add(1, 'M')).startOf('month').format('YYYY-MM-DD')
        },

        monthCalcPaymentsAccommodation () {
            return this.$store.state.monthCalcPaymentsAccommodation;
        },

        itemsPerPage () {
            return this.$store.getters.itemsPerPage
        },

        hasFamilyTotalPayment() {
            if (!this.family) return false;

            const val = this.family.totalPayment;
            if (val === null || val === undefined) return false;

            return !this.decUtil.toDec(val).isZero();
        },

        pickupClientInfoIsSameAsResource() {
          if (!this.updatedResource || !this.pickupClientInfo) {
            return false;
          }

          const resourcePickupDate = this.updatedResource.pickup_date
            ? dayjs(this.updatedResource.pickup_date).format('YYYY-MM-DD')
            : null;

          const clientPickupDate = this.pickupClientInfo.pickup_date
            ? dayjs(this.pickupClientInfo.pickup_date).format('YYYY-MM-DD')
            : null;

          if (this.pickupClientInfo.pickup_type === this.updatedResource.pickup_type) {
            if (this.updatedResource.pickup_type === 'To be confirmed' || this.updatedResource.pickup_type === 'Not applicable') {
              return true;
            }
            if (this.updatedResource.pickup_type === 'Address') {
              return this.updatedResource.pickup_address === this.pickupClientInfo.pickup_address && 
                resourcePickupDate === clientPickupDate && 
                this.updatedResource.pickup_time === this.pickupClientInfo.pickup_time;
            }
            if (this.updatedResource.pickup_type === 'Flight') {
              return this.updatedResource.pickup_nr === this.pickupClientInfo.pickup_nr && 
                this.updatedResource.pickup_company === this.pickupClientInfo.pickup_company && 
                resourcePickupDate === clientPickupDate && 
                this.updatedResource.pickup_time === this.pickupClientInfo.pickup_time;
            }
            if (this.updatedResource.pickup_type === 'Bus') {
              return this.updatedResource.pickup_company === this.pickupClientInfo.pickup_company && 
                this.updatedResource.pickup_from === this.pickupClientInfo.pickup_from && 
                resourcePickupDate === clientPickupDate && 
                this.updatedResource.pickup_time === this.pickupClientInfo.pickup_time;
            }
          }
          return false;
        },

        checkIfPickupDateIsStart() {
          const resourcePickupDate = this.updatedResource.pickup_date
            ? dayjs(this.updatedResource.pickup_date).format('YYYY-MM-DD')
            : null;

          const resourceStartDate = this.updatedResource.start
            ? dayjs(this.updatedResource.start).format('YYYY-MM-DD')
            : null;

          if (resourcePickupDate === resourceStartDate) {
            return true;
          }
          return false;

        },
    },

    beforeCreate () {
        if (this.$store.state.accessAccommodation === 0) {
            this.$router.push({ name: 'Illegal' })
        }
        this.$store.dispatch('setLoadingApp', 1)
    },

    created () {
        dayjs.locale("en");
        this.initialize()
    },

    methods: {
        async initialize () {
            // console.log('initialize', this.$route.params.resourceId)
            let n = new Date();
            this.nowDate = this.formattedDate(n, 'date');

            var date = new Date();
            let start = date.getTime();
            console.log('initialize ***1');

            // this.$store.dispatch('getContacts');
            let previousView =  this.$store.state.breadcrumbs[this.$store.state.breadcrumbs.length - 1];
            console.log('initialize', previousView)
            if (previousView === 'AccommodationPaymentForm') {
                this.tab = 1;
            }
            if (previousView === 'FichaDeAlojamiento') {
                this.tab = 2;
            }
            if (this.$route.params.resourceId) {
                this.scopeResourcesPlanned = 'notPlaced';
            }
            await this.getData();
            await this.getResources();
            await this.determineFichas();
            await this.calcPaymentsMonth();
            await this.$store.dispatch('breadcrumbs', ['Accommodation']);
            if (this.$route.params.resourceId) {
                this.openDialogEditResource(this.$route.params.resourceId);
                this.$store.dispatch('saveDataForReport', );
            } else {
                this.$store.dispatch('setLoadingApp', 0);
            }

            date = new Date();
            let end = date.getTime();
            let totalTime = ((end-start)/1000);
            console.log('initialize ***2', totalTime);
        },

        formatMoney(val) {
            if (val === null || val === undefined) return null;
            return this.decUtil.format(val);
        },

        hasMoney(val) {
            if (val === null || val === undefined) return false;
            return !this.decUtil.toDec(val).isZero();
        },

        async getData() {
            await Promise.all([this.$store.dispatch('getRooms'), this.$store.dispatch('getAccommodations'), this.$store.dispatch('getAccommodationPrices'), this.$store.dispatch('getContacts')]).then((values) => {
                this.updatedRooms = JSON.parse(JSON.stringify(values[0]));
                this.updatedAccommodations = JSON.parse(JSON.stringify(values[1]));
                this.updatedAccPrices = JSON.parse(JSON.stringify(values[2]));
            });
        },

        async determineFichas() {
            this.updatedApartments = [];
            this.updatedFamilies = [];
            // console.log('getData ###1', this.updatedAccommodations.length)
            for (let index = 0; index < this.updatedAccommodations.length; index++) {
                let accommodation = this.updatedAccommodations[index].contact_id;
                let resourcesTmp = this.resourcesLoaded.filter(function(select_item) {
                    return select_item.contact_id === accommodation && select_item.end !== null && select_item.start >= dayjs().format('YYYY-MM-DD');
                });
                this.updatedAccommodations[index].reservations = resourcesTmp.length;
                // console.log('getData ###2', resourcesTmp.length)
                if (resourcesTmp.length > 0) {
                    this.updatedAccommodations[index].send = true;
                } else {
                    this.updatedAccommodations[index].send = false;
                }
                if (this.updatedAccommodations[index].family === 1) {
                    this.updatedFamilies.push(this.updatedAccommodations[index])
                } else {
                    this.updatedApartments.push(this.updatedAccommodations[index])
                }
            }
            this.filterFamilias();
        },

      filterFamilias() {
        // console.log('familias', this.showFamilies)
        if (this.showFamilies === 'active') {
            this.filteredFamilies = this.updatedFamilies.filter(function(select_item) {
                return select_item.obsoleteAcc === null;
            });
        } else {
            this.filteredFamilies = this.updatedFamilies.filter(function(select_item) {
                return select_item.obsoleteAcc !== null;
            });
        }
      },

      async getResources() {

        var date = new Date();
        let start = date.getTime();
        console.log('getResources ***1', this.resourcesLoaded.length);

        this.resourcesLoaded = [];
        if (this.scopeResourcesPlanned === 'completed') {
            this.resourcesLoaded = await this.$store.dispatch('getResourcesAllAccommodations');
        } else {
            this.resourcesLoaded = await this.$store.dispatch('getResourcesAccommodations');
        }

        for (let i = 0; i < this.resourcesLoaded.length; i++) {
            (this.resourcesLoaded[i].start) ? this.resourcesLoaded[i].start = this.formattedDate(this.resourcesLoaded[i].start, "date") : this.resourcesLoaded[i].start = null;
            (this.resourcesLoaded[i].end) ? this.resourcesLoaded[i].end = this.formattedDate(this.resourcesLoaded[i].end, "date") : this.resourcesLoaded[i].end = null;
            (this.resourcesLoaded[i].date_price) ? this.resourcesLoaded[i].date_price = this.formattedDate(this.resourcesLoaded[i].date_price, "date") : this.resourcesLoaded[i].date_price = null;
            (this.resourcesLoaded[i].info_to_client) ? this.resourcesLoaded[i].info_to_client = this.formattedDate(this.resourcesLoaded[i].info_to_client, "date") : this.resourcesLoaded[i].info_to_client = null;
            (this.resourcesLoaded[i].info_to_provider) ? this.resourcesLoaded[i].info_to_provider = this.formattedDate(this.resourcesLoaded[i].info_to_provider, "date") : this.resourcesLoaded[i].info_to_provider = null;
            (this.resourcesLoaded[i].reserved) ? this.resourcesLoaded[i].reserved = this.formattedDate(this.resourcesLoaded[i].reserved, "date") : this.resourcesLoaded[i].reserved = null;
            (this.resourcesLoaded[i].family === 0) ? this.resourcesLoaded[i].family = '0' : this.resourcesLoaded[i].family = '1';
            (this.resourcesLoaded[i].security_deposit === 0) ? this.resourcesLoaded[i].security_deposit = '' : this.resourcesLoaded[i].security_deposit;
            if (this.resourcesLoaded[i].start === null || this.resourcesLoaded[i].end === null) {
                this.resourcesLoaded[i].isSelectable = false;
            }

            this.resourcesLoaded[i].contact_full_name = this.resourcesLoaded[i].organisationName + ' ' + this.resourcesLoaded[i].contact_full_name;

            // get accName and contact info
            if (this.resourcesLoaded[i].room_id) {
                let roomId = this.resourcesLoaded[i].room_id;
                let room = this.updatedRooms.filter(function(select_item) {
                    return select_item.id === roomId;
                });
                this.resourcesLoaded[i].accName = room[0].accName;
                this.resourcesLoaded[i].contact_id = room[0].contact_id;
                this.resourcesLoaded[i].accommodation_id = room[0].accommodation_id;
                this.resourcesLoaded[i].emailContact = room[0].emailContact;
            }

        }

        this.filterResources();

        date = new Date();
        let end = date.getTime();
        let totalTime = ((end-start)/1000);
        console.log('getResources ***2', totalTime);

        
        this.$store.dispatch('setLoadingApp', 0);
        
      },

      filterResources() {

        if (this.scopeResourcesPlanned === 'completed') {
            this.resourcesScope = this.resourcesLoaded.filter(function(select_item) {
                return select_item.statusResourceId === 1 || select_item.statusResourceId === 15;
            });
        } else if (this.scopeResourcesPlanned === 'notPlaced') {
            this.resourcesScope = this.resourcesLoaded.filter(function(select_item) {
                return (select_item.statusResourceId === 6 || select_item.statusResourceId === 5 || select_item.statusResourceId === 7 || select_item.statusResourceId === 9) && select_item.statusResourceId !== 8;
            });
        } else if (this.scopeResourcesPlanned === 'placed') {
            this.resourcesScope = this.resourcesLoaded.filter(function(select_item) {
                return select_item.room_id !== null && select_item.statusResourceId !== 6  && select_item.statusResourceId !== 5 && select_item.statusResourceId !== 7 && select_item.statusResourceId !== 8 && select_item.statusResourceId !== 9 ;
            });
        } else if (this.scopeResourcesPlanned === 'notConfirmed') {
            this.resourcesScope = this.resourcesLoaded.filter(function(select_item) {
                return select_item.statusResourceId === 8 ;
            });
        } else if (this.scopeResourcesPlanned === 'ongoing') {
            this.resourcesScope = this.resourcesLoaded.filter(function(select_item) {
                return select_item.statusResourceId !== 15 && select_item.statusResourceId !== 1;
            });
        }

        this.resourcesPaymentMonth = this.resourcesLoaded.filter(function(select_item) {
            return select_item.statusResourceId === 2 || select_item.statusResourceId === 3 || select_item.statusResourceId === 4 || select_item.statusResourceId === 5 || select_item.statusResourceId === 6 || select_item.statusResourceId === 7;
        });

      },

      dateCalendar(week) {
                return this.addDays(this.startCalendar, 7 * (week - 1))
        },

        addDays(startDate, days) {
            let new_date = dayjs(startDate).add(days, 'd');
            let day = new_date.format('DD');
            let month = new_date.format('MM');
            let year = new_date.format('YYYY');
            return year + '-' + month + '-' + day
        },

        getStatusResource(id) {
            if (id) {
                return this.$store.state.statusResources.filter((select_item) => {
                    return select_item.id === id;
                })[0];
            } else {
                return [];
            }
        },

        async openDialogEditResource(id) {
            // console.log('openDialogEditResource', '%%%%%%%%%1', id)
            this.updatingResources = true
            this.$store.dispatch('setLoadingApp', 1);
            let result = this.resourcesLoaded.filter(function(select_item) {
                return select_item.id === id;
            });
            // console.log('openDialogEditResource', '%%%%%%%%%2', this.resourcesLoaded.length, result)
            if (result.length === 0) {
                result = await this.$store.dispatch('getResourceId', id);
            } else {
                result = result[0];
            }
            // console.log('openDialogEditResource', '%%%%%%%%%2b', result)
            this.updatedResource = Object.assign({}, result);
            if (this.updatedResource.family == 1) {
                // console.log('openDialogEditResource test1', this.updatedResource.family);
                await this.calcPaymentResource(this.updatedResource);
            } else {
                this.updatedResource.payment = 0;
            }
            this.availableRooms = await this.filterRooms(this.updatedResource);
            if (this.updatedResource.client_id !== null) {
              const clientInfo = await this.$store.dispatch('getClientId', this.updatedResource.client_id);
              this.pickupClientInfo = {
                pickup_type: clientInfo.pickup_type,
                pickup_address: clientInfo.pickup_address,
                pickup_company: clientInfo.pickup_company,
                pickup_from: clientInfo.pickup_from,
                pickup_date: clientInfo.pickup_date,
                pickup_time: clientInfo.pickup_time,
                pickup_nr: clientInfo.pickup_nr,
              }
            }
            this.$store.dispatch('setLoadingApp', 0);
            this.dialogEditResource = true;
            
        },

        async openDialogEditMultipleResources() {
            // console.log('openDialogEditMultipleResources', '%%%%%%%%%1', this.selectedReservation)
            this.updatingResources = true
            this.$store.dispatch('setLoadingApp', 1);
            this.resourcesMultiple = Object.assign({}, this.selectedReservation[0]);
            if (this.resourcesMultiple.room_id === null) {
                this.resourcesMultiple.room_id_label = "Room*";
            } else {
                this.resourcesMultiple.room_id_label = "Room";
            }
            if (this.resourcesMultiple.start === null) {
                this.resourcesMultiple.start_label = "from*";
            } else {
                this.resourcesMultiple.start_label = "from";
            }
            if (this.resourcesMultiple.end === null) {
                this.resourcesMultiple.end_label = "until*";
            } else {
                this.resourcesMultiple.end_label = "until";
            }
            if (this.resourcesMultiple.comments === null) {
                this.resourcesMultiple.comments_label = "Comments (255 max)*";
            } else {
                this.resourcesMultiple.comments_label = "Comments (255 max)";
            }
            this.resourcesMultiple.clearComments = false;
            if (this.resourcesMultiple.extras === null) {
                this.resourcesMultiple.extras_label = "Pickup, Fixed & Extras (PEN)*";
            } else {
                this.resourcesMultiple.extras_label = "Pickup, Fixed & Extras (PEN)";
            }
            if (this.resourcesMultiple.info_to_provider === null) {
                this.resourcesMultiple.info_to_provider_label = "Info to placement*";
            } else {
                this.resourcesMultiple.info_to_provider_label = "Info to placement";
            }
            this.resourcesMultiple.clearInfoToPlacement = false;
            if (this.resourcesMultiple.info_to_provider === null) {
                this.resourcesMultiple.reserved_label = "Reserved*";
            } else {
                this.resourcesMultiple.reserved_label = "Reserved";
            }
            this.resourcesMultiple.clearReserved = false;
            if (this.resourcesMultiple.info_to_client === null) {
                this.resourcesMultiple.info_to_client_label = "Info to client*";
            } else {
                this.resourcesMultiple.info_to_client_label = "Info to client";
            }
            this.resourcesMultiple.clearInfoToClient = false;
            for (let index = 1; index < this.selectedReservation.length; index++) {
                if (this.selectedReservation[index].room_id !== this.resourcesMultiple.room_id) {
                    this.resourcesMultiple.room_id = null;
                    this.resourcesMultiple.room_id_label = "Room";
                }
                if (this.selectedReservation[index].start !== this.resourcesMultiple.start) {
                    this.resourcesMultiple.start = null;
                    this.resourcesMultiple.start_label = "from";
                }
                if (this.selectedReservation[index].end !== this.resourcesMultiple.end) {
                    this.resourcesMultiple.end = null;
                    this.resourcesMultiple.end_label = "until";
                }
                if (this.selectedReservation[index].comments !== this.resourcesMultiple.comments) {
                    this.resourcesMultiple.comments = null;
                    this.resourcesMultiple.comments_label = "Comments (255 max)";
                }
                if (this.selectedReservation[index].extras !== this.resourcesMultiple.extras) {
                    this.resourcesMultiple.extras = null;
                    this.resourcesMultiple.extras_label = "Pickup, Fixed & Extras (PEN)";
                }
                if (this.selectedReservation[index].info_to_provider !== this.resourcesMultiple.info_to_provider) {
                    this.resourcesMultiple.info_to_provider = null;
                    this.resourcesMultiple.info_to_provider_label = "Info to placement";
                }
                if (this.selectedReservation[index].reserved !== this.resourcesMultiple.reserved) {
                    this.resourcesMultiple.reserved = null;
                    this.resourcesMultiple.reserved_label = "Reserved";
                }
                if (this.selectedReservation[index].info_to_client !== this.resourcesMultiple.info_to_client) {
                    this.resourcesMultiple.info_to_client = null;
                    this.resourcesMultiple.info_to_client_label = "Info to client";
                }
            }
            console.log('openDialogEditMultipleResources', '%%%%%%%%%3')
            this.availableRooms = await this.getAllRooms(this.resourcesMultiple);
            this.$store.dispatch('setLoadingApp', 0);
            this.dialogEditMultipleResources = true;
            console.log('openDialogEditMultipleResources', '%%%%%%%%%4')
        },

        async calcPaymentResource(resource) {
            // console.log('calcPaymentResource', resource);

            let paymentDec = this.decUtil.toDec(0);
            let paymentDescription = '';

            if (resource.family == 1) {
                const roomId = resource.room_id;

                if (roomId) {
                // ---------------------------------
                // Resolve accommodation
                // ---------------------------------
                const room = this.updatedRooms.find(r => r.id === roomId);
                if (!room) {
                    console.warn('Room not found for resource', resource);
                    return;
                }

                resource.accommodation_id = room.accommodation_id;
                resource.duration = Math.ceil(
                    this.diffDates(resource.start, resource.end)
                );
                resource.currency = 'S/.';

                // ---------------------------------
                // Normalize extras
                // ---------------------------------
                const extrasDec = this.decUtil.toDec(resource.extras ?? 0);

                // ---------------------------------
                // Base payment (dates + rates)
                // ---------------------------------
                let basePayment;

                [basePayment, paymentDescription] =
                    this.calcPaymentAccDates(
                    resource.accommodation_id,
                    resource.start,
                    resource.end,
                    resource.accommodation_class
                    );

                paymentDec = this.decUtil.toDec(basePayment);

                // ---------------------------------
                // Extras
                // ---------------------------------
                if (!extrasDec.isZero()) {
                    paymentDec = paymentDec.plus(extrasDec);
                    paymentDescription +=
                    ` + ${this.decUtil.format(extrasDec)} PEN extras `;
                }
                }
            }

            // ---------------------------------
            // IO boundary
            // ---------------------------------
            resource.payment = paymentDec.toNumber();
            resource.paymentDescription = paymentDescription.trim();
            this.updatedResource = resource;
        },

        async calcPaymentsMonth() {
            console.log('calcPaymentsMonth', this.resourcesPaymentMonth);

            const startTime = Date.now();

            const paymentsMap = new Map();
            this.paymentsContactsRender = [];

            for (const r of this.resourcesPaymentMonth) {
                if (!r.accommodation_id) continue;

                // ---------------------------------
                // Filter family / non-family
                // ---------------------------------
                if (this.monthCalcPaymentsAccommodation.type === 'family') {
                  if (r.family != 1) continue;
                } else {
                  if (r.family == 1) continue;
                }

                // ---------------------------------
                // Normalize paid amount
                // ---------------------------------
                const paidReceiverDec = this.decUtil.toDec(
                  r.amountPaidReceiver ?? 0
                );

                // ---------------------------------
                // Determine last pay day
                // ---------------------------------
                const lastPayDay =
                this.startOfNextMonth < r.end
                    ? this.startOfNextMonth
                    : r.end;

                // ---------------------------------
                // Base payment from date logic
                // ---------------------------------

                let alreadyPaidMinusExtras = this.decUtil
                  .toDec(r.amountPaidReceiver ?? 0)
                  .minus(this.decUtil.toDec(r.extras ?? 0))
                  .toNumber();

                let [baseToPay, paymentDescription, nightsToBePaid] =
                this.calcPaymentAccDates(
                    r.accommodation_id,
                    r.start,
                    lastPayDay,
                    r.accommodation_class,
                    alreadyPaidMinusExtras
                );

                let toPayDec = this.decUtil.toDec(baseToPay);

                // ---------------------------------
                // Extras
                // ---------------------------------
                const extrasDec = this.decUtil.toDec(r.extras ?? 0);
                if (!extrasDec.isZero()) {
                  toPayDec = toPayDec.plus(extrasDec);
                  paymentDescription += ` + ${this.decUtil.format(extrasDec)} PEN extras `;
                }

                // ---------------------------------
                // Subtract paid
                // ---------------------------------
                if (!paidReceiverDec.isZero()) {
                  toPayDec = toPayDec.minus(paidReceiverDec);
                  paymentDescription += ` - ${this.decUtil.format(paidReceiverDec)} PEN paid `;
                }

                // ---------------------------------
                // Nights
                // ---------------------------------
                const nightsShouldBePaidTotal = Number(
                  this.calcNights(r.start, lastPayDay)
                );

                // ---------------------------------
                // Assign back to resource (IO boundary)
                // ---------------------------------
                r.nightsShouldBePaidTotal = nightsShouldBePaidTotal;
                r.nightsShouldBePaidNow = nightsToBePaid;
                r.lastPayDay = lastPayDay;
                r.toPayNow = this.decUtil.format(toPayDec);
                r.paymentDescription = paymentDescription;

                r.paymentDescriptionReport = paymentDescription
                .replaceAll("night(s)", "noche(s)")
                .replaceAll("extras", "recojo")
                .replaceAll("paid", "pagado");

                // ---------------------------------
                // Group by family
                // ---------------------------------
                if (!toPayDec.isZero() && nightsShouldBePaidTotal > 0) {
                const key = r.contact_full_name;

                if (!paymentsMap.has(key)) {
                    paymentsMap.set(key, {
                    family: key,
                    contact_id: r.contact_id,
                    totalPaymentDec: toPayDec,
                    emailContact: r.emailContact,
                    resources: [r]
                    });
                } else {
                    const existing = paymentsMap.get(key);
                    existing.resources.push(r);
                    existing.totalPaymentDec =
                    existing.totalPaymentDec.plus(toPayDec);
                }
                }
            }

            // ---------------------------------
            // Finalize grouped payments
            // ---------------------------------
            const paymentsContacts = Array.from(paymentsMap.values())
                .map(p => ({
                ...p,
                totalPayment: this.decUtil.format(p.totalPaymentDec)
                }))
                .sort(this.dynamicSort('family'));

            this.paymentsContactsRender =
                JSON.parse(JSON.stringify(paymentsContacts));

            const totalTime = (Date.now() - startTime) / 1000;
            console.log('Time building payments: ', totalTime);
        },
        
        calcPaymentAccDates(accommodation_id, start, end, accommodation_class, alreadyPaidMinusExtras) {

            // console.log('calcPaymentAccDates', accommodation_id, start, end, accommodation_class, alreadyPaidMinusExtras);

            let paymentDescription = '';
            let totalDec = this.decUtil.toDec(0);
            let nightsToBePaid = 0;
            let paidRemainingDec = this.decUtil.toDec(alreadyPaidMinusExtras ?? 0);

            // ---------------------------------
            // Load and sort price changes
            // ---------------------------------
            const priceChanges = this.updatedAccPrices
                .filter(p =>
                p.accommodation_id === accommodation_id &&
                p.date_price < end
                )
                .sort(this.dynamicSort('date_price'));

            if (
                priceChanges.length === 0 ||
                this.formattedDate(priceChanges[0].date_price, 'date') > start
            ) {
                this.$store.dispatch(
                'errorMessage',
                `Accommodation nr ${accommodation_id} does not have initial prices defined!`
                );
                return [0, 'null', 0];
            }

            // ---------------------------------
            // Helper to add a segment
            // ---------------------------------
            const addSegment = (from, to, priceSource) => {
                const nights = Number(this.calcNights(from, to));
                if (nights <= 0) return;

                const rate = this.getRateAcc(priceSource, accommodation_class);
                const segmentDec = this.decUtil
                    .toDec(nights)
                    .times(rate);

                totalDec = totalDec.plus(segmentDec);

                // Count only nights that are not already covered by previous payments.
                // Payments are consumed chronologically, using the rate of this segment.
                if (paidRemainingDec.greaterThanOrEqualTo(segmentDec)) {
                    paidRemainingDec = paidRemainingDec.minus(segmentDec);
                } else {
                    const unpaidSegmentDec = segmentDec.minus(paidRemainingDec);
                    const unpaidNightsDec = rate.isZero()
                        ? this.decUtil.toDec(0)
                        : unpaidSegmentDec.dividedBy(rate);

                    nightsToBePaid += Math.ceil(unpaidNightsDec.toNumber());
                    paidRemainingDec = this.decUtil.toDec(0);
                }

                paymentDescription +=
                    ` + ${nights} night(s) x ${this.decUtil.format(rate)} PEN `;
            };

            // ---------------------------------
            // Case: all nights under same rate
            // ---------------------------------
            if (start >= priceChanges[priceChanges.length - 1].date_price) {
                const nights = Number(this.calcNights(start, end));
                const rate = this.getRateAcc(
                    priceChanges[priceChanges.length - 1],
                    accommodation_class
                );

                totalDec = this.decUtil
                  .toDec(nights)
                  .times(rate);

                paymentDescription =
                  `${nights} night(s) x ${this.decUtil.format(rate)} PEN `;

                const unpaidDec = totalDec.minus(paidRemainingDec);
                nightsToBePaid = unpaidDec.greaterThan(0) && !rate.isZero()
                    ? Math.ceil(unpaidDec.dividedBy(rate).toNumber())
                    : 0;

                // if (accommodation_id === 35) {
                //   console.log(
                //     "calcPaymentAccDates ***",
                //     totalDec.toNumber(),
                //     paymentDescription.trim(),
                //     nightsToBePaid
                //   )
                // }

                return [
                  totalDec.toNumber(),
                  paymentDescription.trim(),
                  nightsToBePaid
                ];
            }

            // ---------------------------------
            // Case: price changes within range
            // ---------------------------------
            let prevPrice = priceChanges[0];

            for (let i = 0; i < priceChanges.length; i++) {
                const current = priceChanges[i];

                if (current.date_price > start) {
                  const from =
                      prevPrice.date_price < start
                      ? start
                      : prevPrice.date_price;

                  addSegment(from, current.date_price, prevPrice);

                  if (i === priceChanges.length - 1) {
                      addSegment(
                      current.date_price,
                      end,
                      current
                      );
                  }

                }

                prevPrice = current;
            }

            // ---------------------------------
            // Cleanup description
            // ---------------------------------
            if (paymentDescription.startsWith(' + ')) {
                paymentDescription = paymentDescription.substring(3);
            }

            return [
                totalDec.toNumber(),
                paymentDescription.trim(),
                nightsToBePaid
            ];
        },

        getRateAcc(priceChange, accommodation_class) {
            if (!priceChange) {
                console.warn('getRateAcc: missing priceChange');
                return this.decUtil.toDec(0);
            }

            let rate;

            switch (accommodation_class) {
                case 'Private Room':
                rate = priceChange.price_private;
                break;

                case 'Shared Room':
                case 'Private Double':
                case 'Private Twin':
                rate = priceChange.price_shared;
                break;

                case 'Shared Bunk':
                rate = priceChange.price_bunk;
                break;

                default:
                console.warn(
                    'getRateAcc: unknown accommodation_class',
                    accommodation_class
                );
                rate = 0;
            }

            // Canonical: always return Decimal
            return this.decUtil.toDec(rate ?? 0);
        },

        async filterRooms(resource) {
            console.log('filterRooms start', resource);

            if (!resource || (resource.family != 0 && resource.family != 1)) {
                return [];
            }

            // ---------------------------------
            // Step 1: Filter base rooms
            // ---------------------------------
            let listRooms = this.updatedRooms
                .filter(r =>
                r.family == resource.family &&
                r.obsoleteAcc === null &&
                r.obsoleteRoom === null
                )
                .sort(this.dynamicSort('contact'));

            // const test = this.updatedRooms.filter(room => room.contact_id === 240);

            // console.log('filterRooms 1', test);

            // ---------------------------------
            // Step 2: Load placed resources
            // ---------------------------------
            const resourcesPlaced = await this.$store.dispatch(
                'getResourcesAccommodationsPlaced',
                { start: resource.start, end: resource.end }
            );

            // Pre-group room mates by room_id (O(n))
            const roomMatesMap = new Map();
            for (const placed of resourcesPlaced) {
                if (!roomMatesMap.has(placed.room_id)) {
                roomMatesMap.set(placed.room_id, []);
                }
                roomMatesMap.get(placed.room_id).push(placed);
            }

            // ---------------------------------
            // Step 3: Evaluate each room
            // ---------------------------------
            for (const room of listRooms) {

                room.success = false;

                // Base label
                let entry = `${room.roomSelectName} (`;

                if (room.single_beds > 0) entry += `${room.single_beds}s, `;
                if (room.double_beds > 0) entry += `${room.double_beds}d, `;
                if (room.bunk_places > 0) entry += `${room.bunk_places}b, `;

                entry = entry.slice(0, -2) + ')';
                const baseLength = entry.length;

                const roomMates = roomMatesMap.get(room.id) || [];

                // -----------------------------
                // Compatibility rules
                // -----------------------------

                // Beds availability
                if (
                (resource.accommodation_class === 'Private Room' ||
                resource.accommodation_class === 'Shared Room') &&
                room.single_beds === 0 &&
                room.double_beds === 0
                ) {
                entry += ' - no beds';
                }

                if (
                resource.accommodation_class === 'Shared Bunk' &&
                room.bunk_places === 0
                ) {
                entry += ' - no bunks';
                }

                // Bathroom rule
                if (
                resource.accommodation_class !== 'Shared Bunk' &&
                resource.private_bathroom == 1 &&
                room.private_bathroom == 0
                ) {
                entry += ' - no private bathroom';
                }

                // Family preferences
                if (resource.family == 1) {
                if (
                    resource.pets_preference === 'No pets please' &&
                    room.pets === 'have pets'
                ) {
                    entry += ' - have pets';
                }

                if (
                    resource.food_preference === 'I am vegetarian' &&
                    room.vegetarian === 'no vegetarian'
                ) {
                    entry += ' - no vegetarian';
                }

                if (
                    resource.food_preference === 'I am vegan' &&
                    room.vegan === 'no vegan'
                ) {
                    entry += ' - no vegan';
                }
                }

                // -----------------------------
                // Occupancy rules
                // -----------------------------

                const totalBeds = room.single_beds + room.double_beds;

                switch (resource.accommodation_class) {

                case 'Private Room':
                    if (roomMates.length > 0) entry += ' - not available';
                    else if (totalBeds > 1) entry += ' - more beds';
                    else if (room.double_beds > 0 && room.single_beds === 0)
                    entry += ' - double bed';
                    break;

                case 'Private Double':
                    if (roomMates.length > 1) entry += ' - not available';
                    else if (room.double_beds === 0) entry += ' - no double bed';
                    else if (totalBeds > 1) entry += ' - more beds';
                    break;

                case 'Private Twin':
                    if (roomMates.length > 1) entry += ' - not available';
                    else if (totalBeds < 2) entry += ' - not enough beds';
                    else if (totalBeds > 2) entry += ' - more beds';
                    break;

                case 'Shared Room':
                    if (totalBeds === 1) entry += ' - private room';
                    else if (roomMates.length === totalBeds)
                    entry += ' - not available';
                    else if (
                    roomMates.length === 1 &&
                    ['Private Room', 'Private Double', 'Private Twin']
                        .includes(roomMates[0].accommodation_class)
                    ) {
                    entry += ' - private occupied';
                    }
                    break;

                case 'Shared Bunk':
                    if (roomMates.length === room.bunk_places)
                    entry += ' - not available';
                    break;
                }

                // Success flag
                if (entry.length === baseLength) {
                room.success = true;
                }

                room.listEntry = entry;
            }

            if (resource.room_id) {
                const selectedRoom = this.updatedRooms.find(r => r.id === resource.room_id);

                if (selectedRoom && !listRooms.some(r => r.id === resource.room_id)) {
                    listRooms.unshift(selectedRoom); // add on top
                }
            }
            return listRooms;
        },

        async getAllRooms (resourcesMultiple) {
            console.log('getAllRooms', '%%%%%%%%%1', resourcesMultiple);
            if (resourcesMultiple.family !== null && resourcesMultiple.family) {
                let listRooms = this.updatedRooms.filter(function(select_item) {
                    return select_item.family == resourcesMultiple.family && select_item.obsoleteAcc === null && select_item.obsoleteRoom === null;
                });
                listRooms.sort(this.dynamicSort('contact'));
                for (let index = 0; index < listRooms.length; index++) {
                    listRooms[index].listEntry = listRooms[index].roomSelectName + " (";
                    if (listRooms[index].single_beds > 0) {
                        listRooms[index].listEntry = listRooms[index].listEntry + listRooms[index].single_beds + "s, "
                    }
                    if (listRooms[index].double_beds > 0) {
                        listRooms[index].listEntry = listRooms[index].listEntry + listRooms[index].double_beds + "d, "
                    }
                    if (listRooms[index].bunk_places > 0) {
                        listRooms[index].listEntry = listRooms[index].listEntry + listRooms[index].bunk_places + "b, "
                    }
                    listRooms[index].listEntry = listRooms[index].listEntry.slice(0, -2) + ")";
                }
                console.log('getAllRooms', '%%%%%%%%%2');
                return listRooms;
            }
        },

        async insertUpdateResource() {
            this.$store.dispatch('setLoadingApp', 1);
            this.updatingResources = true;
            this.selectedReservation = [];
            await this.calcPaymentResource(this.updatedResource);
            if (this.updatedResource.date_price !== null) {
                this.updatedResource.date_price = this.formattedDate(this.updatedResource.date_price, 'date');
            }
            this.updatedResource.extras = Number(this.updatedResource.extras);
            // get amount of security deposit from room_id
            this.updatedResource.security_deposit = 0;
            if (this.updatedResource.room_id !== null) {
                this.updatedResource.security_deposit = this.updatedRooms.find(room => room.id === this.updatedResource.room_id).security_deposit;
            }
            let payload = {
                client: null,
                applications: null,
                services: null,
                radioGroups: null,
                radioOptions: null,
                options: null,
                resources: [],
            };
            payload.resources.push(this.updatedResource);
            // console.log('insertUpdateResource ######### 6', payload);
            let results = await this.$store.dispatch('insertUpdateMainItems', payload);
            // console.log('insertUpdateResource ######### 7',results);
            if (results) {
                results = results.data.resources;
                console.log('insertUpdateResource ######### 8',results);
                let posResults = results.findIndex(obj => obj.id == this.updatedResource.id);
                this.updatedResource = results[posResults];
                // console.log('insertUpdateResource ######### 9', this.updatedResource, results[posResults], posResults);
                if (this.updatedResource.family == 1) {
                    this.updatedResource.family = true;
                } else if (this.updatedResource.family == 0) {
                    this.updatedResource.family = false;
                }
                if (this.updatedResource.private_bathroom == 1) {
                    this.updatedResource.private_bathroom = true;
                } else if (this.updatedResource.private_bathroom == 0) {
                    this.updatedResource.private_bathroom = false;
                }
            }
            
            await this.getResources();
            await this.calcPaymentsMonth();
            this.updatingResources = false;
            this.$store.dispatch('setLoadingApp', 0);
        },

        async insertUpdateResourcesMultiple() {
            this.updatingResources = true;
            this.dialogEditMultipleResources = false;
            let sqlTxt = '';
            this.$store.dispatch('progressAdvance', 0);
            this.$store.dispatch('showProgressBar', true);
            let progress = 0;
            let step = 100/this.selectedReservation.length;
            for (let index = 0; index < this.selectedReservation.length; index++) {
                sqlTxt = ' ';
                if (this.resourcesMultiple.room_id !== null) {
                    this.selectedReservation[index].room_id = this.resourcesMultiple.room_id;
                    sqlTxt = sqlTxt.concat(', room_id = ', this.resourcesMultiple.room_id);
                } else if (this.resourcesMultiple.clearRoomId) {
                    this.selectedReservation[index].room_id = null;
                    sqlTxt = sqlTxt.concat(', room_id = null');
                }
                if (this.resourcesMultiple.start !== null) {
                    this.selectedReservation[index].start = this.formattedDate(this.resourcesMultiple.start, 'date');
                    sqlTxt = sqlTxt.concat(", start = '", this.resourcesMultiple.start, "'");
                }
                if (this.resourcesMultiple.end !== null) {
                    this.selectedReservation[index].end = this.formattedDate(this.resourcesMultiple.end, 'date');
                    sqlTxt = sqlTxt.concat(", end = '", this.resourcesMultiple.end, "'");
                }
                if (this.resourcesMultiple.comments !== null) {
                    this.selectedReservation[index].comments = this.resourcesMultiple.comments;
                    sqlTxt = sqlTxt.concat(', comments = ', this.resourcesMultiple.comments);
                } else if (this.resourcesMultiple.clearComments) {
                    this.selectedReservation[index].comments = null;
                    sqlTxt = sqlTxt.concat(', comments = null');
                }
                if (this.resourcesMultiple.info_to_provider !== null) {
                    this.selectedReservation[index].info_to_provider = this.resourcesMultiple.info_to_provider;
                    sqlTxt = sqlTxt.concat(", info_to_provider = '", this.resourcesMultiple.info_to_provider, "'");
                } else if (this.resourcesMultiple.clearInfoToPlacement) {
                    this.selectedReservation[index].info_to_provider = null;
                    sqlTxt = sqlTxt.concat(', info_to_provider = null');
                }
                if (this.resourcesMultiple.reserved !== null) {
                    this.selectedReservation[index].reserved = this.resourcesMultiple.reserved;
                    sqlTxt = sqlTxt.concat(", reserved = '", this.resourcesMultiple.reserved, "'");
                } else if (this.resourcesMultiple.clearReserved) {
                    this.selectedReservation[index].reserved = null;
                    sqlTxt = sqlTxt.concat(', reserved = null');
                }
                if (this.resourcesMultiple.info_to_client !== null) {
                    this.selectedReservation[index].info_to_client = this.resourcesMultiple.info_to_client;
                    sqlTxt = sqlTxt.concat(", info_to_client = '", this.resourcesMultiple.info_to_client, "'");
                } else if (this.resourcesMultiple.clearInfoToClient) {
                    this.selectedReservation[index].info_to_client = null;
                    sqlTxt = sqlTxt.concat(', info_to_client = null');
                }
                if (sqlTxt !== ' ') {
                    await this.calcPaymentResource(this.selectedReservation[index]);
                    sqlTxt = sqlTxt.slice(2);
                    sqlTxt = sqlTxt.concat(' WHERE id = ', this.selectedReservation[index].id);
                    await this.$store.dispatch('updateResourceSafe', sqlTxt);
                }
                progress = progress + step;
                this.$store.dispatch('progressAdvance', progress);
            }
            this.$store.dispatch('showProgressBar', false);
            this.$store.dispatch('progressAdvance', 100);
            this.$store.dispatch('setLoadingApp', 1);
            await this.getResources();
            this.resourcesScope = [];
            for (let index = 0; index < this.selectedReservation.length; index++) {
                let tmpId = this.selectedReservation[index].id;
                let tmp = this.resourcesLoaded.filter(function(select_item) {
                    return select_item.id === tmpId;
                })[0];
                this.resourcesScope.push(tmp);
            }
            this.updatingResources = false;
            this.$store.dispatch('setLoadingApp', 0);
        },

        openContactInfo(editedAcc) {
            let tmp = editedAcc.contact_id;
            this.contact = this.$store.state.contacts.filter(function(select_item) {
                return select_item.id === tmp;
            })[0]
            this.dialogContactInfo = true;
        },

        goClient(id, resourceId) {
            this.$store.dispatch('setLoadingApp', 1);
            this.$router.push({ name: 'Client', params: { id: id, resourceId: resourceId } })
        },

        setObsoleteAcc(event) {
            if (event) {
                this.editedAcc.obsoleteAcc = dayjs().format("YYYY-MM-DD")
            } else {
                this.editedAcc.obsoleteAcc = null
            }
        },

        setObsoleteRoom(event) {
            if (event) {
                this.editedRoom.obsoleteRoom = dayjs().format("YYYY-MM-DD");
            } else {
                this.editedRoom.obsoleteRoom = null;
            }
            
        },

        editAcc (item) {
            this.editedIndexAcc = this.updatedAccommodations.indexOf(item);
            this.editedAcc = Object.assign({}, item);
            this.openDialogAcc();
        },

        openDialogAcc () {
            // console.log('openDialogAcc start', this.editedAcc, this.updatedAccPrices)
            let tmp = this.editedAcc.id;
            let objects = this.updatedAccPrices.filter(function(select_item) {
                return select_item.accommodation_id === tmp;
            })
            this.editedAcc.prices = JSON.parse(JSON.stringify(objects));
            console.log('openDialogAcc', this.editedAcc)
            this.dialogAcc = true;
        },

        editRooms (item) {
            this.editedIndexRoom = this.updatedAccommodations.indexOf(item);
            this.editedAcc = Object.assign({}, item);
            this.getRoomsAcc(this.editedAcc.id)
            this.dialogRooms = true;
        },

        getRoomsAcc(accId) {
            this.editRoomsTable = this.updatedRooms.filter(function(select_item) {
                return select_item.accommodation_id === accId;
            })
        },

        editRoom (item) {
            this.editedIndexRoom = this.updatedRooms.indexOf(item);
            this.editedRoom = Object.assign({}, item);
            this.dialogRoom = true;
        },

        deleteAcc (item) {
            this.editedIndexAcc = this.updatedAccommodations.indexOf(item);
            this.editedAcc = Object.assign({}, item);
            let tmp = this.editedAcc.id;
            if (this.updatedRooms.filter(function(select_item) {
                return select_item.accommodation_id === tmp;
            }).length > 0) {
                this.$store.dispatch('errorMessage', 'Remove first the rooms in the accommodation');
            } else {
                this.dialogDeleteAcc = true;
            }
        },

        async deleteAccConfirm () {
            await this.$store.dispatch('deleteAccommodation', this.editedAcc.id)
            await this.getData();
            this.closeDeleteAcc();
        },

        async deleteRoom (item) {
            this.editedIndexRoom = this.updatedRooms.indexOf(item);
            this.editedRoom = Object.assign({}, item);
            let roomUsed = await this.$store.dispatch('getResourcesRoomId', item.id);
            console.log(item.id, roomUsed.length)
            if (roomUsed.length > 0) {
                this.$store.dispatch('errorMessage', 'Room is being used. You can put it in obsolete instead');
            } else {
                this.dialogDeleteRoom = true;
            }
        },

        async deleteRoomConfirm () {
            await this.$store.dispatch('deleteRoom', this.editedRoom.id);
            await this.getData();
            this.getRoomsAcc(this.editedAcc.id);
            this.dialogDeleteRoom = false;
            // this.closeDeleteRoom();
        },

        closeAcc () {
            this.currentFile = undefined;
            this.file = null;
            this.editedAcc = Object.assign({}, this.defaultAcc);
            this.editedIndexAcc = -1;
            this.getData();
        },

        closeRoom () {
            this.editedRoom = Object.assign({}, this.defaultRoom)
            this.editedIndexRoom = -1
        },

        closeDeleteAcc () {
            this.dialogDeleteAcc = false;
            this.editedAcc = Object.assign({}, this.defaultAcc)
            this.editedIndexAcc = -1
        },

        async saveAccTotal () {
            this.$store.dispatch('setLoadingApp', 1);
            if(this.$refs.dialogFormAcc.validate()) {
                (!this.editedAcc.security_deposit) ? (this.editedAcc.security_deposit = 0) : (this.editedAcc.security_deposit);
                this.editedAcc.comments = this.editedAcc.commentsAcc;
                this.editedAcc.obsolete = this.editedAcc.obsoleteAcc;
                (!this.editedAcc.obsolete) ? (this.editedAcc.obsolete = null) : (this.editedAcc.obsolete = this.formattedDate(this.editedAcc.obsolete,'date'));
                if (this.editedAcc.contact_id) {
                    let tmp = this.editedAcc.contact_id;
                    let contactName = this.$store.state.contacts.filter(function(select_item) {
                        return select_item.id === tmp;
                    })
                    this.editedAcc.contact = contactName[0].name
                } else {
                    this.editedAcc.contact = null
                }
                let results = await this.$store.dispatch('insertAccommodation', this.editedAcc);
                this.editedAcc.prices.sort(this.dynamicSort('date_price'));
                for (let i = 0; i < this.editedAcc.prices.length; i++) {
                    (!this.editedAcc.prices[i].date_price) ? (this.editedAcc.prices[i].date_price = null) : (this.editedAcc.prices[i].date_price = this.formattedDate(this.editedAcc.prices[i].date_price,'date'));
                    if (results.insertId !== 0) {
                        this.editedAcc.prices[i].accommodation_id = results.insertId;
                    }
                    let thisAcc = [];
                    if (this.editedAcc.prices[i].id) {
                        let tmp = this.editedAcc.prices[i].id;
                        thisAcc = this.updatedAccPrices.filter(function(select_item) {
                            return select_item.id === tmp;
                        })[0];
                        thisAcc.date_price = this.formattedDate(thisAcc.date_price, 'date');
                    }
                    //console.log('saveAccTotal 2');
                    if (!this.editedAcc.prices[i].id || !this.sameArrays(thisAcc, this.editedAcc.prices[i])) {
                        console.log('saveAccTotal 3');
                        await this.$store.dispatch('insertAccommodationPrices', this.editedAcc.prices[i]);
                    }
                }
                // console.log('saveAccTotal 5', this.updatedAccPrices, this.editedAcc.prices);
                let tmp = this.editedAcc.id;
                let thisAcc = this.updatedAccPrices.filter(function(select_item) {
                    return select_item.accommodation_id === tmp;
                })
                for (let i = 0; i < thisAcc.length; i++) {
                    let tmp = thisAcc[i].id;
                    let result = this.editedAcc.prices.filter(function(select_item) {
                        return select_item.id === tmp;
                    })
                    if (result.length === 0) {
                        await this.$store.dispatch('deleteAccommodationPrices', tmp);
                    }
                }
                //console.log('saveAccTotal 6', this.editedAcc.filename, this.editedAcc.file_id, this.selectFileaccommodationDescription);
                if (this.editedAcc.filename === null && this.editedAcc.file_id !== null) {
                    await this.deleteFile(this.editedAcc.file_id);
                } else if (this.selectFileaccommodationDescription) {
                    await this.uploadFile("accommodationDescription");
                }
                await this.initialize();
                this.dialogAcc = false;
                this.closeAcc()
            }
            this.$store.dispatch('setLoadingApp', 0);
        },

        async saveRoom () {
            if(this.$refs.dialogFormRoom.validate()){
            let tmp = this.editedRoom.name;
            let double = this.editRoomsTable.filter(function(select_item) {
                return select_item.name === tmp;
            })
            if (double.length > 0 && this.nameChange) {
                this.$store.dispatch('errorMessage', 'Name ' + tmp + ' already in use');
                this.nameChange = false;
            } else {
                this.nameChange = false;
                this.editedRoom.accommodation_id = this.editedAcc.id;
                this.editedRoom.comments = this.editedRoom.commentsRoom;
                this.editedRoom.obsolete = this.editedRoom.obsoleteRoom;
                if (this.editedRoom.single_beds === '' || this.editedRoom.single_beds === null) {
                    this.editedRoom.single_beds = 0;
                }
                if (this.editedRoom.double_beds === '' || this.editedRoom.double_beds === null) {
                    this.editedRoom.double_beds = 0;
                }
                if (this.editedRoom.bunk_places === '' || this.editedRoom.bunk_places === null) {
                    this.editedRoom.bunk_places = 0;
                }
                await this.$store.dispatch('insertRoom', this.editedRoom);
                await this.getData();
                this.getRoomsAcc(this.editedAcc.id);
                console.log('updated')
                this.dialogRoom = false;
                this.closeRoom()
            }
            }
        },

        async saveCalcPaymentsAccommodation (acc, month) {
            this.$store.dispatch('setLoadingApp', 1);
            // console.log('saveCalcPaymentsAccommodation')
            let payload = {
                type: acc,
                month: month,
            };
            await this.$store.dispatch('monthCalcPaymentsAccommodation', payload);
            // console.log('saveCalcPaymentsAccommodation 2')
            await this.calcPaymentsMonth();
            // console.log('saveCalcPaymentsAccommodation 3')
            this.$store.dispatch('setLoadingApp', 0);
        },

        calcNights(startDate, endDate) {
            let nights = dayjs(endDate).diff(dayjs(startDate), 'd');
            return nights.toFixed(0);
        },

        addPayment(family) {
            this.$store.dispatch('setLoadingApp', 1)
            this.$router.push({ name: 'Financial', params: { paymentFamily: family, paymentProfe: null, appId: null, transId: null } })
        },

        async goPaymentAccommodationForm (family) {
            family.startOfNextMonth = this.startOfNextMonth;
            family.startOfMonth = this.startOfMonth;
            family.emailFamily = family.emailContact;
            console.log('goPaymentAccommodationForm', family);
            await this.$store.dispatch('saveDataForReport', family);
            this.$router.push({ name: 'PaymentAccommodationForm'});
        },

        diffDates(startDate, endDate) {
            let days = dayjs(endDate).diff(dayjs(startDate), 'd');
            return days.toFixed(0);
        },

        openTransactionOutgoings(transIdOutgoings) {
            this.$store.dispatch('setLoadingApp', 1)
            this.$router.push({ name: 'Financial', params: { transIdOutgoings: transIdOutgoings } })
        },
            
        checkResourceDates(resource) {
            if(resource.info_to_provider === null) {
                resource.info_to_provider = resource.info_to_client;
            }
            if(resource.reserved === null) {
                resource.reserved = resource.info_to_client;
            }
        },

        selectResourceReservation() {
            // console.log('selectResourceReservation', this.selectedReservation);
            if (this.selectedReservation.length === 0) {
                this.filterResources();
                this.selectedReservationSingleSelect = true;
                return;
            } else {
                let contact_id = this.selectedReservation[0].contact_id;
                // let accommodation_class = this.selectedReservation[0].accommodation_class;
                this.selectedReservationSingleSelect = false;
                this.resourcesScope = this.resourcesScope.filter(function(select_item) {
                    return select_item.contact_id === contact_id;
                });
                this.infoToClientPossible = true;
                this.infoToAccommodation = this.selectedReservation[0].contact_id;
                this.openMultipleResourcesPossible = true;
                let accommodation_class = this.selectedReservation[0].accommodation_class;
                for (let index = 0; index < this.selectedReservation.length; index++) {
                    if (this.selectedReservation[index].room_id === null) {
                        this.infoToClientPossible = false;
                        this.infoToAccommodation = null;
                    }
                    if (this.selectedReservation[index].email === null) {
                        this.infoToClientPossible = false;
                    }
                    if (this.selectedReservation[index].accommodation_class !== accommodation_class) {
                        this.openMultipleResourcesPossible = false;
                    }
                    if (this.infoToAccommodation !== null && this.selectedReservation[index].contact_id !== this.infoToAccommodation) {
                        console.log('selectResourceReservation #3', this.selectedReservation[index].contact_id, this.infoToAccommodation);
                        this.infoToAccommodation = null;
                    }
                    console.log('selectResourceReservation #3', this.selectedReservation[index].contact_id, this.infoToAccommodation);
                }
            }
        },

        async goFichaDeAlojamiento (family) {

            this.$store.dispatch('setLoadingApp', 1);

            try {

                // console.log('goFichaDeAlojamiento', family, dayjs().format('YYYY-MM-DD'));
                // get resources from family with end date not passed
                let resourcesTmp = [];
                if (this.tab === 0) {
                    resourcesTmp = this.selectedReservation;
                } else {
                    resourcesTmp = this.resourcesLoaded.filter(function(select_item) {
                        return select_item.contact_id === family && select_item.end !== null && select_item.start >= dayjs().format('YYYY-MM-DD');
                    });
                }
                // console.log('goFichaDeAlojamiento #2', resourcesTmp);
                if (resourcesTmp.length === 0) {
                    this.$store.dispatch('errorMessage', 'No reservations found for this accommodation');
                    return;
                }
                let load = {};
                let payload = [];

                const sqlTxt = resourcesTmp
                    .map(r => `id = ${r.client_id}`)
                    .join(' OR ');

                // console.log('goFichaDeAlojamiento 3b', sqlTxt);
                let clients = await this.$store.dispatch('getClientsSafe',sqlTxt);
                for (let i = 0; i < resourcesTmp.length; i++) {
                    let clientId = resourcesTmp[i].client_id;
                    let client = clients.filter(function(select_item) {
                        return select_item.id === clientId;
                    })[0];
                    let n = new Date();
                    if (!resourcesTmp[i].info_to_provider) {
                        resourcesTmp[i].info_to_provider = this.formattedDate(n,'date');
                    }
                    resourcesTmp[i].reserved = this.formattedDate(n,'date');
                    resourcesTmp[i].info_to_client = null;
                    load = {
                        client: client,
                        resource: resourcesTmp[i],
                    }
                    payload.push(load);
                }
                
                const today = dayjs().format('ddd DD MMM YY');

                const messageHeader = `
                    <div style="margin-top:0; font-family:Raleway,Arial,Helvetica,sans-serif;">
                    <div style="display:flex; justify-content:space-between;">
                        <div style="font-family:Roboto; font-size:32px; color:#35b729;">
                        <span>PROYECTO</span><strong>PERU</strong>
                        </div>
                        <div style="text-align:right; color:grey;">
                        <div style="font-size:24px;">Ficha de Cliente</div>
                        <div style="font-size:14px;"><i>¡Brindando nuevas oportunidades para vivir</i></div>
                        <div style="font-size:14px;"><i>experiencias culturales inolvidables a</i></div>
                        <div style="font-size:14px;"><i>través de voluntariados y hospedaje con familias!</i></div>
                        <div style="font-size:18px;">Cusco, ${today}</div>
                        </div>
                    </div>

                    <h1>Alojamiento ${payload[0].resource.contact_full_name}</h1>
                    <h3>Reservaciones por venir:</h3>
                    </div>
                `;

                const messageBody = `
                    <div style="margin-top:1cm;background:#c7d3d1;height:4px;"></div>
                    ${payload.map(p => this.buildAccommodationBlock(p)).join('')}
                `;

                this.messageHTML = `
                    ${messageHeader}
                    <div style="margin-top:1cm; background:#c7d3d1; height:4px;"></div>
                    ${messageBody}
                    <div style="margin-top:3cm; background:#c7d3d1; height:2px;"></div>
                    <div style="text-align:center; font-size:14px;">
                    Proyecto Peru Centre, Arcopata 466 Cusco, Peru
                    </div>
                    <div style="text-align:center; font-size:14px;">
                    Tel. +51 (084) 240 278 / 950 301 317 – office@proyectoperucentre.org
                    </div>
                `;
                this.dialogFichaDeAlojamiento = true;
                this.$store.dispatch('setLoadingApp', 0)
                

            } finally {
                this.$store.dispatch('setLoadingApp', 0);
            }


            
        },

        buildAccommodationBlock({ client, resource }) {
            const gender =
                client.gender === 'Male' ? 'Masculino' :
                client.gender === 'Female' ? 'Femenino' :
                'No conocido';

            const nationality = this.getNationalityName(client.nationality_id);

            const diet =
                client.food_preference === 'Not known' ? 'por confirmar' :
                client.food_preference === 'I am not vegetarian neither vegan' ? 'normal' :
                client.food_preference === 'I am vegetarian' ? 'vegetariana' :
                client.food_preference === 'I am vegan' ? 'vegana' :
                null;

            const accommodationClass =
                resource.accommodation_class === 'Shared Room' ? 'Compartido' :
                resource.accommodation_class === 'Private Room' ? 'Privado' :
                'No conocido';


            let pickupBlock = '';
            if (client.pickup_type) {
                pickupBlock += `
                <div style="margin-top:1cm;"><i>Pickup</i></div>
                <div style="background:#c7d3d1;height:2px;"></div>
                `;

                if (client.pickup_type === 'Flight') {
                pickupBlock += `
                    <div><strong>Vuelo:</strong> ${client.pickup_nr}</div>
                    <div><strong>Compañía:</strong> ${client.pickup_company}</div>
                    <div><strong>Llegando desde:</strong> ${client.pickup_from}</div>
                    <div><strong>Fecha:</strong> ${dayjs(client.pickup_date).format('ddd DD MMM YY')}</div>
                    <div><strong>Hora (hh:mm):</strong> ${client.pickup_time}</div>
                `;
                } else if (client.pickup_type === 'Bus') {
                pickupBlock += `
                    <div><strong>Bus:</strong> ${client.pickup_company}</div>
                    <div><strong>Llegando desde:</strong> ${client.pickup_from}</div>
                    <div><strong>Fecha:</strong> ${dayjs(client.pickup_date).format('ddd DD MMM YY')}</div>
                    <div><strong>Hora (hh:mm):</strong> ${client.pickup_time}</div>
                `;
                } else if (client.pickup_type === 'Address') {
                pickupBlock += `
                    <div><strong>Dirección:</strong> ${client.pickup_address}</div>
                    <div><strong>Fecha:</strong> ${dayjs(client.pickup_date).format('ddd DD MMM YY')}</div>
                    <div><strong>Hora (hh:mm):</strong> ${client.pickup_time}</div>
                `;
                } else if (client.pickup_type === 'To be confirmed') {
                pickupBlock += `<div><strong>Para Confirmar</strong></div>`;
                }
            }

            return `
                <div style="margin-top:1cm;">
                <strong>Nombre:</strong> ${resource.full_name}
                </div>

                ${nationality ? `<div><strong>Nacionalidad:</strong> ${nationality}</div>` : ''}
                ${client.birthdate ? `<div><strong>Edad:</strong> ${dayjs().diff(client.birthdate, 'year')}</div>` : ''}
                <div><strong>Género:</strong> ${gender}</div>
                ${client.occupation ? `<div><strong>Ocupación / Profesión:</strong> ${client.occupation}</div>` : ''}
                ${client.email ? `<div><strong>Email:</strong> ${client.email}</div>` : ''}
                ${diet ? `<div><strong>Dieta:</strong> ${diet}</div>` : ''}
                ${resource.comments ? `<div><strong>Comentario:</strong> ${resource.comments}</div>` : ''}

                <div style="margin-top:1cm;"><i>Estadía</i></div>
                <div style="background:#c7d3d1;height:2px;"></div>
                <div><strong>Tiempo:</strong> ${resource.duration} noches</div>
                <div><strong>Dormitorio:</strong> ${accommodationClass}</div>
                <div><strong>Día de llegada:</strong> ${dayjs(resource.start).format('ddd DD MMM YY')}</div>
                <div><strong>Día de salida:</strong> ${dayjs(resource.end).format('ddd DD MMM YY')}</div>

                ${pickupBlock}

                <div style="margin-top:1cm;background:#c7d3d1;height:6px;"></div>
            `;
        },

        getNationalityName (nationalityId) {
          if (nationalityId === null) return null;
          const nationality = this.$store.state.itemsNationality.filter(c => c.id === nationalityId)[0];
          return nationality ? nationality.country_name_es : null;
        },

        async deleteAccPrice (item) {
            // console.log('deleteAccPrice', item, this.editedAcc.prices);
            let pos = 0;
            pos = this.editedAcc.prices.map(function(e) { return e.id; }).indexOf(item.id);
            if (pos > -1) {
                this.editedAcc.prices.splice(pos, 1);
            }
            // console.log('deleteAccPrice 2', this.editedAcc.prices);
            this.rendererDialogAccTable = Math.random();
        },

        openDialogAccPrices () {
            this.editedAccPrices.date_price = this.nowDate;
            this.editedAccPrices.price_private = 0;
            this.editedAccPrices.price_shared = 0;
            this.editedAccPrices.price_bunk = 0;
            this.dialogAccPrices = true;
        },

        editAccPrice (item) {
            this.editedAccPrices = item;
            this.dialogAccPrices = true;
        },

        saveAccPrice (item) {
            // console.log('saveAccPrice', item, this.editedAccPrices, this.editedAcc.prices);
            let pos = 0;
            pos = this.editedAcc.prices.map(function(e) { return e.id; }).indexOf(item.id);
            if (pos === -1) {
                item.accommodation_id = this.editedAcc.id;
                this.editedAcc.prices.push(item);
            }
            this.dialogAccPrices = false;
            this.rendererDialogAccTable = Math.random();
            // console.log('saveAccPrice 2', this.editedAcc.prices);
        },

        allowedMonths(val) {
            // console.log('allowedMonths', val > this.addDays(this.nowDate, -15))
            return val > this.addDays(this.nowDate, -45);
        },

        sameArrays(arrayOne, arrayTwo) {
            let arrayOneJSON = JSON.stringify(arrayOne);
            let arrayTwoJSON = JSON.stringify(arrayTwo);
            let result = (arrayOneJSON === arrayTwoJSON);
            return result;
        },

        clearRoomId(event) {
            if (this.resourcesMultiple.room_id !== null && event) {
                this.resourcesMultiple.room_id = null;
            }
        },

        clearComments(event) {
            if (this.resourcesMultiple.comments !== null && event) {
                this.resourcesMultiple.comments = null;
            }
        },

        clearInfoToPlacement(event) {
            if (this.resourcesMultiple.info_to_provider !== null && event) {
                this.resourcesMultiple.info_to_provider = null;
            }
        },

        clearReserved(event) {
            if (this.resourcesMultiple.reserved !== null && event) {
                this.resourcesMultiple.reserved = null;
            }
        },

        clearInfoToClient(event) {
            if (this.resourcesMultiple.info_to_client !== null && event) {
                this.resourcesMultiple.info_to_client = null;
            }
        },

        async sendInfoToClientConfirm() {
            console.log('sendInfoToClientConfirm #1', this.selectedReservation);
            this.accommodationDescription = await this.$store.dispatch('getAccommodationDescription_id', this.selectedReservation[0].accommodation_id);
            if (this.accommodationDescription) {
                let agency = {};
                let tmp = null;
                for (let index = 0; index < this.selectedReservation.length; index++) {
                    tmp = this.selectedReservation[index].agency;
                    agency = this.$store.state.available_agencies.filter(function(select_item) {
                        return select_item.name === tmp;
                    })[0];
                    console.log('sendInfoToClientConfirm #2', agency);
                    this.selectedReservation[index].cc = null;
                    if (agency) {
                        if (agency.contactToEmail) {
                            this.selectedReservation[index].email = this.getContactEmail(agency.contactToEmail);
                        }
                        if (agency.contactToCC) {
                            this.selectedReservation[index].cc = this.getContactEmail(agency.contactToCC);
                        }
                    }
                }
                this.dialogConfirmSendInfoToClient = true;
            } else {
                this.$store.dispatch('errorMessage', 'No description found for accommodation ' + this.selectedReservation[0].contact_full_name);
            }
        },

        async sendInfoToClient() {
            console.log('sendInfoToClient', this.selectedReservation);
            this.$store.dispatch('setLoadingApp', 1);
            let payload = {
                client: null,
                applications: null,
                services: null,
                radioGroups: null,
                radioOptions: null,
                options: null,
                resources: [],
            };
            for (let index = 0; index < this.selectedReservation.length; index++) {
                let emailIntro = '<!DOCTYPE html><html><head><meta charset="utf-8"></head><body>';
                let attachments = [];
                if (this.selectedReservation[index].family == 1) {
                    emailIntro = "Dear " + this.selectedReservation[index].full_name + ",<br/><br/>" +
                        this.selectedReservation[index].contact_full_name + "'s family is thrilled to welcome you to your home in Cusco. Please, find your host family description attached!<br/><br/>"
                } else {
                    emailIntro = "Dear " + this.selectedReservation[index].full_name + ",<br/><br/>" +
                        "We are thrilled to welcome you to Cusco. Please, find your Apartment/Volunteer House description attached!<br/><br/>"
                }
                emailIntro += "Continue checking your inbox for your 'First-week schedule' (sent within one week before arrival), where we will send you the final details of your pick-up and orientation.<br/><br/>" +
                        "Kind Regards, <br/><br/>" +
                        this.$store.state.user + "<br/><br/>" +
                        "office@proyectoperucentre.org<br/>" +
                        "Proyecto Peru Centre<br/>" +
                        "Avenida Arcopata 466-A<br/>" +
                        "Cusco, Cusco, 45<br/>" +
                        "+ 51 84 240 278<br/><br/><br/></body></html>";
                console.log('sendInfoToClient 1', this.accommodationDescription);
                attachments.push(
                    {   
                        filename: this.accommodationDescription.filename,
                        path: this.accommodationDescription.content,
                    },
                );
                let payloadEmail = {
                    submittedFrom: "Accommodation Info to Client",
                    emailList: this.selectedReservation[index].email,
                    // emailList: 'mail4coen@gmail.com',
                    emailSubject: "Information about your Accommodation",
                    messageHTML: emailIntro,
                    messagePlain: "",
                    attachments: attachments,
                    cc: this.selectedReservation[index].cc,
                };
                console.log('sendInfoToClient 2', payloadEmail, attachments);
                this.$store.dispatch('emailNow', payloadEmail);
                let n = new Date();
                if (this.selectedReservation[index].info_to_provider === null) {
                    this.selectedReservation[index].info_to_provider = this.formattedDate(n,'date');
                }
                if (this.selectedReservation[index].reserved === null) {
                    this.selectedReservation[index].reserved = this.formattedDate(n,'date');
                }
                this.selectedReservation[index].info_to_client = this.formattedDate(n,'date');
                payload.resources.push(this.selectedReservation[index]);
            }
            await this.$store.dispatch('insertUpdateMainItems', payload);
            this.dialogConfirmSendInfoToClient = false;
            this.$store.dispatch('setLoadingApp', 0);
        },

        selectFile(file, type) {
            if (file) {
                console.log('selectFile', file.name)
                if (type === 'accommodationDescription') {
                    this.selectFileaccommodationDescription = true;
                    this.currentFile = file;
                    this.editedAcc.filename = file.name;
                    this.$store.dispatch('setFileName', file.name);
                    // this.uploadFile(type);
                } else {
                    this.selectFileaccommodationDescription = false;
                }
            }
        },

        async onDrop(e, type) {
            this.dragover = false;
            if (e.dataTransfer.files.length > 1) {
                this.$store.dispatch('errorMessage', 'Only one file can be uploaded at a time..');
            } else {
                console.log(e.dataTransfer.files[0].type);
                if (type === 'accommodationDescription') {
                    if (e.dataTransfer.files[0].type === 'application/pdf') { 
                        this.selectFileaccommodationDescription = true;
                        this.currentFile = e.dataTransfer.files[0];
                        await this.$store.dispatch('setFileName', this.currentFile.name);
                        this.editedAcc.filename = this.currentFile.name;
                        // this.uploadFile(type);
                    } else {
                        this.$store.dispatch('errorMessage', 'Please add a pdf');
                    }
                }
            }
                
        },
        
        async uploadFile(type) {
          console.log('uploadFile', type);

          const file = this.currentFile;

          if (!file) {
            this.$store.dispatch('successMessage', 'Please select a file');
            return;
          }

          this.$store.dispatch('showProgressBar', true);

          try {
            const dataUrl = await new Promise((resolve, reject) => {
              const reader = new FileReader();

              reader.onload = () => resolve(reader.result);
              reader.onerror = () => reject(
                reader.error || new Error('Failed to read file')
              );

              reader.readAsDataURL(file);
            });

            if (typeof dataUrl !== 'string' || !dataUrl.includes(',')) {
              throw new Error('Invalid file data');
            }

            const base64 = dataUrl.split(',')[1];

            const payload = {
              id: Date.now(),
              accommodation_id: this.editedAcc.id,
              type,
              name: file.name,
              mime_type: file.type || 'application/pdf',
              file_size: file.size,
              file: base64,
              encoding: 'base64',
            };

            await this.$store.dispatch('addUpload', payload);

            console.log('Accommodation description uploaded successfully');

            this.selectFileaccommodationDescription = false;

            // Clear the selected file after successful upload.
            this.currentFile = undefined;
            this.file = null;

            // Refresh the accommodation description list here if necessary.
            // Call the existing action used to load this accommodation's files.
          } catch (error) {
            console.error('Accommodation description upload failed:', error);
          } finally {
            this.$store.dispatch('showProgressBar', false);
          }
        },

        downloadFileAcc (payload) {
            this.$store.dispatch('downloadFileAcc', payload);
        },

        async deleteFile (payload) {
            let result = await this.$store.dispatch('deleteAccommodationDescription', payload);
            console.log('deleteFile', result);
            if (result.statusText === 'OK') {
                this.$store.dispatch('successMessage', 'Description successfully removed!');
            } else {
                this.$store.dispatch('errorMessage', 'Error removing description!');
            }
        },

        printDialogContent() {
            // 1. Select the v-dialog's content
            const dialogContent = document.querySelector('#areatoprint'); // Assuming your dialog content is within a v-card

            // 2. Create a new window for printing
            const printWindow = window.open('', '', 'width=600,height=500');

            // 3. Write the dialog content to the new window
            printWindow.document.write(dialogContent.outerHTML);

            // 4. Close the new window after printing (optional)
            // printWindow.addEventListener('beforeprint', () => {
            //   printWindow.close();
            // });

            // 5. Trigger the print dialog
            printWindow.document.close(); // Important to close the document
            printWindow.print();
            printWindow.close();
            this.dialogFichaDeAlojamiento = false;
        },

        getContactEmail (id) {
            let contact = this.$store.state.contacts.filter(function(select_item) {
                return select_item.id === id;
            })
            if (contact.length === 0) {
                return null;
            } else {
                return contact[0].email;
            }
        },

        async changeScopeResourcesPlanned(value) {
            console.log('changeScopeResourcesPlanned', value);
            this.selectedReservation = [];
            this.$store.dispatch('setLoadingApp', 1);
            await this.getResources();
            this.$store.dispatch('setLoadingApp', 0);
        },


        familyTotalPaymentFormatted(family) {
            if (!family) return null;

            const val = family.totalPayment;
            if (val === null || val === undefined) return null;

            return this.decUtil.format(val);
        },

        copyPickupFromClientInfo() {
          this.updatedResource.pickup_type = this.pickupClientInfo.pickup_type;
          this.updatedResource.pickup_address = this.pickupClientInfo.pickup_address;
          this.updatedResource.pickup_company = this.pickupClientInfo.pickup_company;
          this.updatedResource.pickup_from = this.pickupClientInfo.pickup_from;
          this.updatedResource.pickup_date = this.pickupClientInfo.pickup_date;
          this.updatedResource.pickup_time = this.pickupClientInfo.pickup_time;
          this.updatedResource.pickup_nr = this.pickupClientInfo.pickup_nr;
        }

    },
}

</script>

<style>
    .v-card__title {
        color: #35b729;
        word-break: normal !important;
    }
    .v-card__subtitle { padding-top: 0; padding-bottom: 0;}
    .pos_absolute {
        position: absolute;
    }
    /* .vuecal__cell-split .split-label {color: rgba(0, 0, 0, 0.1);font-size: 26px;} */
    .vuecal__event.Private_Room {background-color: rgba(253, 156, 66, 0.9);color: #fff;}
    .vuecal__event.Private_Double {background-color: rgba(214, 88, 98, 0.9);color: #fff;}
    .vuecal__event.Private_Twin {background-color: rgba(164, 230, 210, 0.9);}
    .vuecal__event.Shared_Room {background-color: rgba(225, 255, 178, 0.5);}
    .vuecal__event.Shared_Bunk {background-color: rgba(164, 230, 210, 0.9);}

    button.vuecal__arrow {display: none;}
    .all_stays:not(:first-of-type) .vuecal__header {display: none;}
    .vuecal__event {height: 60px; border: 0px !important;}
</style>